/**************************
 * Testseek Live API v5.5.0 *
 **************************

 Generated: 2024-04-15 13:54:37 CEST
 Config: {
    "ajax_tracking": "1",
    "aur": {
        "aurs": "1",
        "aurss": "1",
        "title": "1",
        "sscore": "1",
        "sdist": "1",
        "sfeat": "1",
        "spc": "1",
        "sslogo": "1",
        "sslink": "1",
        "ssscore": "1",
        "ssdist": "1",
        "ssfeat": "1",
        "ssrec": "1",
        "aur": false,
        "min_avg_score": null,
        "sort": null,
        "filter_aurss": null
    },
    "aur_full_dataset": null,
    "aureviews": null,
    "design": "1",
    "er": {
        "summary": "1",
        "list": "1",
        "title": "1",
        "score": "1",
        "dist": "1",
        "procons": "1",
        "awards": "1",
        "testseek": "0",
        "count": "5",
        "lscore": "1",
        "vote": "1",
        "awardimg": "1",
        "extlink": "1",
        "logo": "0",
        "frame": "1",
        "sort": "lang,-date,-review_id",
        "filter_lang": "",
        "mcount": null,
        "lproscons": true,
        "poweredby": true,
        "min_avg_score": null,
        "have_score": null,
        "min_score": null
    },
    "ereviews": "3",
    "iconlib": "google",
    "iconlib_url": true,
    "key": "661d0e93",
    "match_type": "MPN+EAN",
    "server": "partner.testseek.com",
    "sort_lang": null,
    "text_lang": "2",
    "ts": 1713182077,
    "vid": {
        "list": "1",
        "vote": "1",
        "filter": "1",
        "rows": "1",
        "sort": "lang,-date,-review_id"
    },
    "videos": null
}

 Templates loaded:
 * rich_snippet
 * stars_only
 * full_66c6cc1d3a


 Included 38 JS-files:

 * asort_num.js
 * aurss_modal_urls.js
 * bar_animate.js
 * config_init.js
 * ereview_vote.js
 * extend_aur.js
 * extend_er.js
 * feature_animate.js
 * handle_message.js
 * handle_respone.js
 * htmlentities.js
 * icons.js
 * init.js
 * init_css.js
 * init_font.js
 * inline_iframe_init.js
 * listners.js
 * load_element.js
 * load_held.js
 * load_more_aur.js
 * load_more_er.js
 * load_template_by_url.js
 * parseQuery.js
 * play_video.js
 * popup.js
 * render_au_review.js
 * render_e_review.js
 * render_element.js
 * render_finish.js
 * render_template.js
 * resize_iframes.js
 * send_vote.js
 * svg_graph_load.js
 * tab_select.js
 * track_ext_link.js
 * update_class.js
 * video_filter.js
 * video_vote.js
 * l10n.en-us.js
 **/

/* Main config */
if(!window.testseek) window.testseek = {};
if(!window.testseek.search_version) window.testseek.search_version = "5.5.0";
if(!window.testseek.key) window.testseek.key = "661d0e93";
if(!window.testseek.ts_domain) window.testseek.ts_domain = "partner.testseek.com";
if(!window.testseek.lang) window.testseek.lang = "en-us";
if(!window.testseek.sort_lang) window.testseek.sort_lang = "2";
if(!window.testseek.show) window.testseek.show = ["base","ers"];
if(!window.testseek.er_count) window.testseek.er_count = 0;
if(!window.testseek.tracking) window.testseek.tracking = true;
if(!window.testseek.icon_library)
{
	window.testseek.icon_library = "google";
	if(!window.testseek.icon_library_url)
	{
		window.testseek.icon_library_url = "https:\/\/fonts.googleapis.com\/icon?family=Material+Icons";
	}
}
if(!window.testseek.templates) window.testseek.templates = {};
if(!window.testseek.template_by_class) window.testseek.template_by_class = {};
if(!window.testseek.template_by_class.ts_stars_template) window.testseek.template_by_class.ts_stars_template = "stars_only";
if(!window.testseek.template_by_class.ts_full_template) window.testseek.template_by_class.ts_main_template = "full_66c6cc1d3a";
if(!window.testseek.popup_template) window.testseek.popup_template = "full_66c6cc1d3a";
if(!window.testseek.template_by_id) window.testseek.template_by_id = {};
if(!window.testseek.template_by_id.ts_rich_snippet) window.testseek.template_by_id.ts_rich_snippet = "rich_snippet";
window.testseek.request_config = {"ajax_tracking":1,"apiversion":"5.5.0","aur":{"aurs":1,"aurss":1,"title":1,"sscore":1,"sdist":1,"sfeat":1,"spc":1,"sslogo":1,"sslink":1,"ssscore":1,"ssdist":1,"ssfeat":1,"ssrec":1,"aur":false,"min_avg_score":null,"sort":null,"filter_aurss":null},"aur_full_dataset":null,"aureviews":null,"cip":1318698318,"design":1,"dl":1,"er":{"summary":1,"list":1,"title":1,"score":1,"dist":1,"procons":1,"awards":1,"testseek":0,"count":5,"lscore":1,"vote":1,"awardimg":1,"extlink":1,"logo":0,"frame":1,"sort":"lang,-date,-review_id","filter_lang":"","mcount":null,"lproscons":true,"poweredby":true,"min_avg_score":null,"have_score":null,"min_score":null},"ereviews":3,"iconlib":"google","iconlib_url":true,"key":"661d0e93","match_type":"MPN+EAN","r":null,"server":"partner.testseek.com","sort_lang":null,"text_lang":2,"ts":1713182077,"vid":{"list":1,"vote":1,"filter":1,"rows":1,"sort":"lang,-date,-review_id"},"videos":null};

/* Templates: */

window.testseek.templates["rich_snippet"] = "{\n\t\"@context\": \"http:\/\/schema.org\/\",\n\t\"@type\": \"Product\",\n\t\"name\": \"%product_name%\",\n\t\"description\": \"%product_name%\",\n\t\"aggregateRating\": {\n\t\t\"@type\": \"AggregateRating\",\n\t\t\"ratingValue\": \"%ts_score%\",\n\t\t\"bestRating\": \"100\",\n\t\t\"worstRating\": \"0\",\n\t\t\"ratingCount\": \"%ts_score_count%\"\n\t}\n}\n";

window.testseek.templates["stars_only"] = "<div onclick=\"window.testseek.popup('%ts_id%');\" style=\"cursor: pointer;\" class=\"ts_hide_stars_if_no_aer_no_aur ts_rate ts_erate %ts_score_class%\" data-score=\"%ts_score%\" title=\"%ts_score%% average score from %ts_score_count% reviews for %product_name% at Testseek\">\n\t\n\t<span class=\"expert-review-count\">(%e_count%) Expert reviews</span><div class=\"ts_stars_rating\">\n\t\t<span class=\"ts_star1\">%icon_star%<\/span>\n\t\t<span class=\"ts_star2\">%icon_star%<\/span>\n\t\t<span class=\"ts_star3\">%icon_star%<\/span>\n\t\t<span class=\"ts_star4\">%icon_star%<\/span>\n\t\t<span class=\"ts_star5\">%icon_star%<\/span>\n\t\t<span class=\"ts_star_half\">%icon_half_star%<\/span>\n\t\t<span class=\"ts_star_e1\">%icon_empty_star%<\/span>\n\t\t<span class=\"ts_star_e2\">%icon_empty_star%<\/span>\n\t\t<span class=\"ts_star_e3\">%icon_empty_star%<\/span>\n\t\t<span class=\"ts_star_e4\">%icon_empty_star%<\/span>\n\t\t<span class=\"ts_star_e5\">%icon_empty_star%<\/span>\n\t<\/div>\n<\/div>";

window.testseek.templates["full_66c6cc1d3a"] = " <div class=\"testseek_main ts_hide_entire_section_if_conditions_are_met\"> <div class=\"ts_show_if_popup ts_close_popup\" title=\"close popover\" onclick=\"testseek.close_popup();\">X<\/div> <a class=\"ext_link_ts\" href=\"https:\/\/www.testseek.com\/b2b\/about-us\/certified-reviews-by-testseek\/\" target=\"_blank\"><img class=\"ts_poweredby_img\" src=\"https:\/\/partner.testseek.com\/images\/testsites\/certified_reviews_testseek_blue_white_bg_180x83.png\" alt=\"[Certified by testseek]\" title=\"These reviews are certified by Testseek as genuine and unbiased. The reviews have been analyzed by both humans and machine.\" \/><\/a> <!-- E-rev --> <div class='l ts_show_if_erev'> <div> <h2 class=\"ts_er_top_header\">Expert reviews of %product_name%<\/h2> <\/div> <div class=\"l\"> <div class=\"ts_rate\"> <svg width=\"104\" height=\"104\" class=\"ts_clock_graph\" data-ts-graph-val=\"%e_score%\" data-id-sufix=\"ers\"> <circle r=\"40\" cy=\"51\" cx=\"51\" fill-opacity=\"0\" stroke=\"#e5e5e5\" stroke-width=\"20\"\/> <circle id=\"fg_ers\" transform=\"rotate(-90 51 51)\" stroke-dasharray=\"0 260\" r=\"40\" cy=\"51\" cx=\"51\" fill-opacity=\"0\" stroke=\"#87d962\" stroke-width=\"20\"\/> <text x=\"51\" y=\"62\" font-size=\"28\" text-anchor=\"middle\" fill=\"black\">%e_score%<\/text> <\/svg> <\/div> <div class=\"ts_edist ts_200n\"> <h3 class=\"er_dist_header\">Distribution of expert ratings (%e_count% expert reviews)<\/h3> <table> <colgroup> <col style=\"width: 50px;\" \/> <col \/> <col style=\"width: 50px;\" \/> <\/colgroup> <tbody> <tr> <th>5 <span class=\"s\">%icon_star%<\/span><\/th> <td><span class=\"ts_bar_bg\"> <span class=\"bar_fg bar_5s ts_bar_animate\" style=\"width: 0%\" data-ts-graph-val=\"%escore_5star_score%\"><\/span> <\/span><\/td> <td>%escore_5star_count%<\/td> <\/tr> <tr> <th>4 <span class=\"s\">%icon_star%<\/span><\/th> <td><span class=\"ts_bar_bg\"> <span class=\"bar_fg bar_4s ts_bar_animate\" style=\"width: 0%\" data-ts-graph-val=\"%escore_4star_score%\"><\/span> <\/span><\/td> <td>%escore_4star_count%<\/td> <\/tr> <tr> <th>3 <span class=\"s\">%icon_star%<\/span><\/th> <td><span class=\"ts_bar_bg\"> <span class=\"bar_fg bar_3s ts_bar_animate\" style=\"width: 0%\" data-ts-graph-val=\"%escore_3star_score%\"><\/span> <\/span><\/td> <td>%escore_3star_count%<\/td> <\/tr> <tr> <th>2 <span class=\"s\">%icon_star%<\/span><\/th> <td><span class=\"ts_bar_bg\"> <span class=\"bar_fg bar_2s ts_bar_animate\" style=\"width: 0%\" data-ts-graph-val=\"%escore_2star_score%\"><\/span> <\/span><\/td> <td>%escore_2star_count%<\/td> <\/tr> <tr> <th>1 <span class=\"s\">%icon_star%<\/span><\/th> <td><span class=\"ts_bar_bg\"> <span class=\"bar_fg bar_1s ts_bar_animate\" style=\"width: 0%\" data-ts-graph-val=\"%escore_1star_score%\"><\/span> <\/span><\/td> <td>%escore_1star_count%<\/td> <\/tr> <tr> <th colspan=\"2\">Unrated<\/th> <td>%escore_noscore_count%<\/td> <\/tr> <\/tbody> <\/table> <\/div> <\/div> <div class=\"l\"> <h3 class=\"er_list_header\">Expert reviews<\/h3> <div class=\"ts_award ts_show_if_ts_award\" style=\"margin-right: 30px;\"><img src=\"%ts_award_url%\" style=\"width: 100px;\"\/><\/div> <p class='ts_show_if_escore'>Testseek has collected %e_count% expert reviews for %product_name% and the average expert rating is %e_full_score% of 100. The average score reflects the expert community's view of this product.<\/p> <p class='ts_show_if_erev ts_hide_if_escore'>partner.testseek.com has collected %e_count% expert reviews for %product_name%.<\/p> <p class='ts_hide_if_erev'>partner.testseek.com has collected 0 expert reviews for %product_name%.<\/p> <div> <span class=\"flag er_ts_flag\" style=\"background-position: -40px -0px\" title=\"locale: en-us\"><\/span> <a class=\"ext_link_ts\" target=\"_blank\" onmousedown=\"testseek.track_this_ts_link(this)\" href=\"%product_url%\">Read all expert reviews at Testseek &raquo;<\/a> <\/div> <\/div> <\/div> <\/div> <br style=\"clear: both;\" \/> ";

/* End of Templates */

/* Start of asort_num.js */
/**
 * Sorting functions
 * asort_num() and its subfunction asort_func()
 */

/**
 * Sort an objects attributes by its numeric values
 * NOTICE: attribute order is not required to be preserved by client.
 *
 * @param {Object} unsorted_object - object the object to sort
 * @param {boolean} desc - reverse order?
 *
 * @return {Object} - object with sorted attributes
 *
 * @depends asort_func
 **/
window.testseek.asort_num = function(unsorted_object, desc)
{
	// if reverse order
	if(desc)
	{
		// use b - a comparison
		return window.testseek.asort_func(
			unsorted_object,
			function (a, b) {
				return (b[1] - a[1]);
			}
		);
	}
	// normal order
	else
	{
		// use a - b comparison
		return window.testseek.asort_func(
			unsorted_object,
			function (a, b) {
				return (a[1] - b[1]);
			}
		);
	}
}

/**
 * Sort an objects attributes by a function
 * NOTICE: attribute order is not required to be preserved by client.
 *
 * @param unsorted_object object the object to sort
 * @param sort_function callable(a, b) where a[0] and b[0] is the name, and a[1] and b[1] is the value
 *
 * @return object with sorted attributes
 **/
window.testseek.asort_func = function(unsorted_object, sort_function)
{
	// a list for attributes
	var data = [];

	// loop all attributes
	for(var key in unsorted_object)
	{
		// append list with an array, where index 0 is the attribute name, and index 1 is the attributes value
		data.push([key, unsorted_object[key]]);
	}

	// sort attributes by given funktion
	data.sort(sort_function);

	// create a new object, that will be given the sorted attributes
	var sorted_object = {};

	// loop list of attributes
	var data_length = data.length;
	for(var index = 0; index < data_length; index++)
	{
		// attach attributes on the new object
		sorted_object[data[index][0]] = data[index][1];
	}

	// return the new object
	return sorted_object;
}
/* End of asort_num.js */

/* Start of aurss_modal_urls.js */

window.testseek.aurss_modal_urls_onresize = function(event) {};

window.testseek.aurss_modal_urls_onclick = function(event) {

    var btnLinkedIn = event.target;

    //if clicked on X, close modal (all), as we don't allow multiple open modals at once
    if ('ts_wtb_close' === btnLinkedIn.className) {
        window.testseek.aurss_modal_close(null, 0xff);
        return;
    }

    if (!btnLinkedIn.classList.contains('ext_link_aur')) return;

    var btnID = btnLinkedIn.id;

    //handle modal via function
    window.testseek.aurss_modal_open(btnID + '-modal');
};

//window.testseek.aurss_modal_close = function (elem = null, closeAll = false) // N/A in WebView mobile browsers
window.testseek.aurss_modal_close = function (elem, closeAll) {

    var allUrlModals = document.getElementsByClassName('ts_aurss_product_urls_modal');

    for (var urlModalObj in allUrlModals) {
        if (allUrlModals.hasOwnProperty(urlModalObj)) {

            var eachModal = allUrlModals[urlModalObj];

            //fix for limited Andorid native WebView browsers xD
            if (!eachModal.id) continue;

            //skip current modal we're dealing with
            if (!closeAll && eachModal.id === elem.id) continue;

            //reset every other modal visibility
            eachModal.style.opacity = 0;
            //reset positions
            //eachModal.style.right = '0px';
            eachModal.style.top = '500px';
            //set z-index
            eachModal.style.zIndex = -1;
        }
    }

};

window.testseek.aurss_modal_open = function (btnID) {

    var allClickedModalsByClassName = document.getElementsByClassName(btnID);

    for (var eachModalToBeOpened in allClickedModalsByClassName) {
        if (allClickedModalsByClassName.hasOwnProperty(eachModalToBeOpened)) {

            var modalLinkedIn = allClickedModalsByClassName[eachModalToBeOpened];

            //fix for limited Andorid native WebView browsers xD
            if (!modalLinkedIn.id) continue;

            //Visibility study
            var isVisibleMijn = modalLinkedIn.style.opacity;

            isVisibleMijn = !isVisibleMijn || '0' === isVisibleMijn ? 1 : 0;

            //set visibility according to user action
            modalLinkedIn.style.opacity = isVisibleMijn;

            //throw it out of focus when closed
            if (!isVisibleMijn) {
                //set z-index
                modalLinkedIn.style.zIndex = -1;
                modalLinkedIn.style.top = '500px';
            }
            else { //activated
                //Modal is locked top right
                modalLinkedIn.style.top = '0px';
                //modalLinkedIn.style.right = '0px';
                //set z-index to visible
                modalLinkedIn.style.zIndex = 1;
            }

            //close any other active modal, if any
            window.testseek.aurss_modal_close(modalLinkedIn);

        }
    }

};/* End of aurss_modal_urls.js */

/* Start of bar_animate.js */
/**
 * Animate bars with the class ts_bar_animate
 *
 * @attribute data-ts-graph-val int[0-100] % of graph to show
 **/

window.testseek.bar_animate = function() {
	// Find all graphs with the class ts_bar_animate
	var graphs = document.getElementsByClassName('ts_bar_animate');

	// loop all matching graphs
	for(var g_nr = graphs.length; g_nr > 0;)
	{
		var graph = graphs[--g_nr];

		// fetch value from attribute
		var value = parseFloat(graph.getAttribute('data-ts-graph-val'));

		// if value exists
		if(value)
		{
			// set width using value
			graph.style.width = value + '%'

			// remove the class, animation done
			graph.classList.remove('ts_bar_animate');
		}
	}
}
/* End of bar_animate.js */

/* Start of config_init.js */
/**
 * init missing config-settings
 */

// init data structure
if(!window.testseek)
{
	window.testseek = {};
}

if(!window.testseek.products)
{
	window.testseek.products = {};
}

if(!window.testseek.mpns)
{
	window.testseek.mpns = {};
}

if(!window.testseek.pids)
{
	window.testseek.pids = {};
}

if(!window.testseek.icecats)
{
	window.testseek.icecats = {};
}

if(!window.testseek.pending)
{
	window.testseek.pending = [];
}


// Init config structure
if(!window.testseek.key)
{
	window.testseek.key = "";
}

if(!window.testseek.lang)
{
	window.testseek.lang = "";
}

if(!window.testseek.sort_lang)
{
	window.testseek.sort_lang = "";
}

if(!window.testseek.er_count && typeof(window.testseek.er_count) != "number")
{
	window.testseek.er_count = 15;
}

/* Nemanja edit: we don't want to hard-code API version, we generate it on the fly or even allow users to make their choice
if(!window.testseek.search_version)
{
	window.testseek.search_version = '5.1';
}
*/

if(!window.testseek.ts_domain)
{
	window.testseek.ts_domain = 'partner.testseek.com';
}

if(!window.testseek.verbose)
{
	window.testseek.verbose = false;
}

if(!window.testseek.vote_url)
{
	window.testseek.vote_url = 'https://' + window.testseek.ts_domain + '/vote.php?';
}

if(!window.testseek.search_url)
{
	window.testseek.search_url = 'https://' + window.testseek.ts_domain + '/json.php?v=' + window.testseek.search_version + '&key=' + window.testseek.key + (window.testseek.sort_lang ? '&lang=' + window.testseek.sort_lang : (window.testseek.lang ? '&lang=' + window.testseek.lang : ''));
}

if(!window.testseek.auto_resize_class)
{
	window.testseek.auto_resize_class = 'ts_resize';
}

if(!window.testseek.tracking)
{
	window.testseek.tracking = false;
}

if(!window.testseek.popup_template)
{
	window.testseek.popup_template = "";
}

if(!window.testseek.icon_library)
{
	window.testseek.icon_library = '';
}

if(!window.testseek.icon_library_url)
{
	window.testseek.icon_library_url = '';
}



if(!window.testseek.filters)
{
	window.testseek.filters = {};
}

if(!window.testseek.filters.er_lang)
{
	window.testseek.filters.er_lang = '';
}

if(!window.testseek.filters.er_have_score)
{
	window.testseek.filters.er_have_score = 0;
}

if(!window.testseek.filters.er_min_score)
{
	window.testseek.filters.er_min_score = 0;
}

if(!window.testseek.filters.product_min_er_score)
{
	window.testseek.filters.product_min_er_score = 0;
}

if(!window.testseek.filters.product_min_aur_score)
{
	window.testseek.filters.product_min_aur_score = 0;
}

if(!window.testseek.filters.er_sort)
{
	window.testseek.filters.er_sort = "";
}

if(!window.testseek.filters.aur_sort)
{
	window.testseek.filters.aur_sort = "";
}

if(!window.testseek.filters.v_sort)
{
	window.testseek.filters.v_sort = "";
}


// Init template config
if(!window.testseek.template_by_class)
{
	window.testseek.template_by_class = {};
}

if(!window.testseek.template_by_id)
{
	window.testseek.template_by_id = {};
}

if(!window.testseek.template_by_tagname)
{
	window.testseek.template_by_tagname = {};
}

if(!window.testseek.templates)
{
	window.testseek.templates = {};
}
/* End of config_init.js */

/* Start of ereview_vote.js */
/**
 * Voteing functions
 */

/**
 * Vote up on a expert review
 *
 * @param id int review_id of the review to vote on
 * @param element HTMLElement where to find values to update vote
 *
 * @depends send_vote
 **/
window.testseek.ereview_vote_up = function(id, element)
{
	// define a callback for what to do when ajax respond
	var callback = function(a, e) {
		// if ajax-vote succeded
		if(a.ok)
		{
			// find the ts_vote_up-classed element
			var elements = e.parentNode.getElementsByClassName('ts_vote_up');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}

			// fetch the old value from the elemnts attribute data-ts-value
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}

			// Set vote-up value to one higher then the old value
			var current_value = parseInt(elements[0].innerHTML);
			var new_value = parseInt(old_value) + 1;
			elements[0].innerHTML = new_value;
			var changed = (new_value != current_value);

			// find the ts_vote_down-classed element
			var elements = e.parentNode.getElementsByClassName('ts_vote_down');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}

			// fetch the old value from the elemnts attribute data-ts-value
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}

			// Restore the vote-down value, decresing it if it was increased by a vote down by this user.
			elements[0].innerHTML = parseInt(old_value);

			var elements = e.parentNode.getElementsByClassName('ts_vote_message');
			if(!elements)
			{
				return true;
			}
			if(!elements[0])
			{
				return true;
			}
			if(!elements[0].getAttribute)
			{
				return true;
			}

			elements[0].innerHTML = window.testseek.htmlentities(window.testseek.l10n(changed ? 'vote_sucess' : 'vote_only_once'));

			return true;
		}

		// ajax failed
		if(window.testseek.verbose)
		{
			// log resonse, for debuging
			console.error(a);
		}

		return false;
	}

	// Call send_vote, using prefix ER (Expert Reviews), and type '+' for vote up
	window.testseek.send_vote('ER', id, '+', callback, element);
}

/**
 * Vote down on a expert review
 *
 * @param id int review_id of the review to vote on
 * @param element HTMLElement where to find values to update vote
 *
 * @depends send_vote
 **/
window.testseek.ereview_vote_down = function(id, element)
{
	// define a callback for what to do when ajax respond
	var callback = function(a, e) {
		if(a.ok)
		{
			// find the ts_vote_down-classed element
			var elements = e.parentNode.getElementsByClassName('ts_vote_down');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}

			// fetch the old value from the elemnts attribute data-ts-value
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}
			var current_value = parseInt(elements[0].innerHTML);
			var new_value = parseInt(old_value) + 1;
			elements[0].innerHTML = new_value;
			var changed = (new_value != current_value);

			// find the ts_vote_up-classed element
			var elements = e.parentNode.getElementsByClassName('ts_vote_up');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}

			// fetch the old value from the elemnts attribute data-ts-value
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}

			// Restore the vote-up value, decresing it if it was increased by a vote up by this user.
			elements[0].innerHTML = parseInt(old_value);

			var elements = e.parentNode.getElementsByClassName('ts_vote_message');
			if(!elements)
			{
				return true;
			}
			if(!elements[0])
			{
				return true;
			}
			if(!elements[0].getAttribute)
			{
				return true;
			}

			elements[0].innerHTML = window.testseek.htmlentities(window.testseek.l10n(changed ? 'vote_sucess' : 'vote_only_once'));

			return true;
		}

		// ajax failed
		if(window.testseek.verbose)
		{
			// log resonse, for debuging
			console.error(a);
		}

		return false;
	}

	// Call send_vote, using prefix ER (Expert Reviews), and type '-' for vote down
	window.testseek.send_vote('ER', id, '-', callback, element);
}
/* End of ereview_vote.js */

/* Start of extend_aur.js */
/**
 * Extend a AU review loop, with more content
 *
 * @param loop_base HTMLElement the element to extend, using its .ts.template
 * @param list array list of review_ids to extend the element with
 *
 * @depends render_e_review, render_finish, render_finish_activate
 **/

window.testseek.extend_aur = function(loop_base, list)
{
	// list to store the new generated html
	var html = [];
	var list_length = list.length;

	// loop all review_ids in the list
	for(var row_nr = 0; row_nr < list_length; row_nr++)
	{
		var review_id = list[row_nr];

		// if the review is already fetched
		if(testseek.aur_content[review_id])
		//if(testseek.ereviews[review_id])
		{
			// render the review data, and push it to the html list
			//items_html.push(window.testseek.render_au_review(loop_base.ts_template, this_aurss_full_review));
			html.push(window.testseek.render_au_review(loop_base.ts_template, testseek.aur_content[review_id]));

			// if review listed as pending
			var pending_row = loop_base.pending.indexOf(review_id);
			if(pending_row > -1)
			{
				// remove it from the list of pending
				loop_base.pending.splice(pending_row, 1);
			}
		}
	}

	// if there are new html
	if(html.length > 0)
	{
		// NOTICE appending innerHTML regenerate all children, not what we want, better to move children
		// create a real htmlelement
		var new_html_elements = document.createElement('div');

		// Put all the html inside it
		new_html_elements.innerHTML += html.join('\n');

		// for all the child elements
		while(new_html_elements.firstChild)
		{
			// move them to real element
			loop_base.appendChild(new_html_elements.firstChild);
		}

		// Call the render_finish-function, to activate animations and iframe content
		window.testseek.render_finish_activate();
	}
}
/* End of extend_aur.js */

/* Start of extend_er.js */
/**
 * Extend a ereview-loop, with more content
 *
 * @param loop_base HTMLElement the element to extend, using its .ts.template
 * @param list array list of review_ids to extend the element with
 *
 * @depends render_e_review, render_finish, render_finish_activate
 **/

window.testseek.extend_er = function(loop_base, list)
{
	// list to store the new generated html
	var html = [];
	var list_length = list.length;

	// loop all review_ids in the list
	for(var row_nr = 0; row_nr < list_length; row_nr++)
	{
		var review_id = list[row_nr];

		// if the review is already fetched
		if(testseek.ereviews[review_id])
		{
			// render the review data, and push it to the html list
			html.push(window.testseek.render_e_review(loop_base.ts_template, testseek.ereviews[review_id]));

			// if review listed as pending
			var pending_row = loop_base.pending.indexOf(review_id);
			if(pending_row > -1)
			{
				// remove it from the list of pending
				loop_base.pending.splice(pending_row, 1);
			}
		}
	}

	// if there are new html
	if(html.length > 0)
	{
		// NOTICE appending innerHTML regenerate all children, not what we want, better to move children
		// create a real htmlelement
		var new_html_elements = document.createElement('div');

		// Put all the html inside it
		new_html_elements.innerHTML += html.join('\n');

		// for all the child elements
		while(new_html_elements.firstChild)
		{
			// move them to real element
			loop_base.appendChild(new_html_elements.firstChild);
		}

		// Call the render_finish-function, to activate animations and iframe content
		window.testseek.render_finish_activate();
	}
}
/* End of extend_er.js */

/* Start of feature_animate.js */
/**
 * animate elements with the class ts_feature_animate
 *
 * @attribute data-ts-graph-val int[0-100] %-value to show
 **/

window.testseek.feature_animate = function() {
	// get all elements with the class ts_feature_animate
	var graphs = document.getElementsByClassName('ts_feature_animate');

	// loop all matching graphs
	for(var g_nr = graphs.length; g_nr > 0;)
	{
		var graph = graphs[--g_nr];

		// fetch the value from the data-ts-graph-val attribute
		var value = parseFloat(graph.getAttribute('data-ts-graph-val'));

		// if there is a value
		if(value)
		{
			// fetch all lines
			var lines = graph.getElementsByTagName("line");

			// fetch the dash-size on the 2nd line (1st is background, 2nd is forground)
			var sizes = lines[1].getAttribute('stroke-dasharray').split(' ');

			// IE 11 fix, somehow IE replaces the spaces with ','
			if(sizes.length==1)
			{
				sizes = lines[1].getAttribute('stroke-dasharray').split(',');
			}

			// 1st dash size is the length of 20% (dash-visible)
			// 2nd dash size is the length of the separator (dash-invisible)
			// calculate the end position = value% * dash-visible/20% + count-of-separators * dash-invisible
			var x2 = value * parseFloat(sizes[0]) / 20 + Math.floor(value / 20) * parseFloat(sizes[1]);

			// set the length of the 2nd line (forground)
			lines[1].setAttribute('x2', x2);

			// for mordern browser
			if(graph.classList)
			{
				// remove animation class, already animated
				graph.classList.remove('ts_feature_animate');
			}
			// Fix for IE 11
			else
			{
				graph.setAttribute("class", (' ' + graph.getAttribute("class") + ' ').replace(/\s+/, ' ').replace(' ts_feature_animate ', ' ') .trim());
			}
		}
	}
}
/* End of feature_animate.js */

/* Start of handle_message.js */
/**
 * Used to share messages between frames
 * (Not needed for the moment, as we found other ways to solve thus problems)
 **/

window.testseek.handle_message = function(e) {
	try
	{
		var data = JSON.parse(e.data);
	}
	catch (error)
	{
		return false;
	}

	if(window.testseek.verbose)
	{
		console.log(data);
	}
	return true;
}
/* End of handle_message.js */

/* Start of handle_respone.js */
/**
 * parse and store returned data from testseeks api
 *
 * @param response the data to parse
 * @param elements array list of HTMLElement to use load_element after the response is handled
 *
 * @depends load_element
 **/

window.testseek.handle_respone = function(response, elements)
{
	// JSON-string? (or JSON parsed object)
	if(typeof response == "string")
	{
		// parse the JSON string in to a object
		response = JSON.parse(response);
	}

	// if response have products
	if(response.products)
	{
		// if we already have products, merge needed
		if(this.products)
		{
			// loop all new products
			for(var key in response.products)
			{
				// if we already have that product
				if(this.products[key])
				{
					// TODO: merge
					if(window.testseek.verbose) {console.log("JS Merge of product, not avaible"); console.log(key); console.log(this.products[key]); console.log(response.products[key]);}
					this.products[key] = response.products[key];
					this.products[key].config = response.config;
				}
				// if we didn't have that product
				else
				{
					// add it to our list
					this.products[key] = response.products[key];
					this.products[key].config = response.config;
				}
			}
		}
		// we don't have products yet
		else
		{
			// just store them as they are
			this.products = response.products;
		}
	}

	// response-types that can be simply merged
	var simple_merge_categories = ['aurss', 'ereviews', 'mpns', 'pids', 'icecats', 'videos', 'test_sites', 'aur_content']; //added aur_content
	var category_count = simple_merge_categories.length;

	// loop thos response-types
	for(var row_nr = 0; row_nr < category_count; row_nr++)
	{
		var cat_key = simple_merge_categories[row_nr];

		// if response have this type
		if(response[cat_key])
		{
			// if we already have this type
			if(this[cat_key])
			{
				// loop all entites in the response
				for(var key in response[cat_key])
				{
					// copy that entity into our list
					this[cat_key][key] = response[cat_key][key];
				}
			}
			// if we don't have this type
			else
			{
				// copy it all
				this[cat_key] = response[cat_key];
			}
		}
	}

	// if we have a list of elements to load
	if(elements)
	{
		var element_count = elements.length;

		// loop all elements
		for(var index = 0; index < element_count; index++)
		{
			// load the element using load_element()
			this.load_element(elements[index], false, true);
		}
	}
}
/* End of handle_respone.js */

/* Start of htmlentities.js */
window.testseek.htmlentities = function(s)
{
	if(!s) return s;
	else if(!s.replace) return s;
	else return s
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
	;
}
/* End of htmlentities.js */

/* Start of icons.js */
window.testseek.icons = function(icon) {
	switch(window.testseek.icon_library)
	{
		case 'fa':
		{
			switch(icon)
			{
				case 'star':
				{
					return '<i class="fa fa-star" aria-hidden="true"></i>';
				}

				case 'empty_star':
				{
					return '<i class="fa fa-star-o" aria-hidden="true"></i>';
				}

				case 'half_star':
				{
					return '<i class="fa fa-star-half-o" aria-hidden="true"></i>';
				}

				case 'tup':
				{
					return '<i class="fa fa-thumbs-o-up" aria-hidden="true"></i>';
				}

				case 'tdown':
				{
					return '<i class="fa fa-thumbs-o-down" aria-hidden="true"></i>';
				}

				default:
				{
					return '';
				}
			}
		}

		case 'google':
		{
			switch(icon)
			{
				case 'star':
				{
					return '<i class="material-icons">star</i>';
				}

				case 'empty_star':
				{
					return '<i class="material-icons">star_border</i>';
				}

				case 'half_star':
				{
					return '<i class="material-icons">star_half</i>';
				}

				case 'tup':
				{
					return '<i class="material-icons">thumb_up</i>';
				}

				case 'tdown':
				{
					return '<i class="material-icons">thumb_down</i>';
				}

				default:
				{
					return '';
				}
			}
		}

		case 'bootstrap':
		{
			switch(icon)
			{
				// bootstrap don't have half-stars
				case 'star':
				case 'half_star':
				{
					return '<i class="glyphicon glyphicon-star"></i>';
				}

				case 'empty_star':
				{
					return '<i class="glyphicon glyphicon-star-empty"></i>';
				}

				case 'tup':
				{
					return '<i class="glyphicon glyphicon-thumbs-up"></i>';
				}

				case 'tdown':
				{
					return '<i class="glyphicon glyphicon-thumbs-down"></i>';
				}

				default:
				{
					return '';
				}
			}
		}

		case '':
		case 'system':
		default:
		{
			switch(icon)
			{
				// unicode don't have half-stars
				case 'star':
				case 'half_star':
				{
					return '&#x2605;';
				}

				case 'empty_star':
				{
					return '&#x2606;';
				}

				case 'tup':
				{
					return '&#x1f44d;';
				}

				case 'tdown':
				{
					return '&#x1f44e;';
				}

				default:
				{
					return '';
				}
			}
		}
	}
}
/* End of icons.js */

/* Start of init.js */
window.testseek.init = function() {
	// list of stuff to ask for
	var pending = [];

	if(this.template_by_class && document.getElementsByClassName)
	{
		for(var ts_element_class in this.template_by_class)
		{
			var elements = document.getElementsByClassName(ts_element_class);
			var element_count = elements.length;
			for(var element_nr = 0; element_nr < element_count; element_nr++)
			{
				this.load_element(elements[element_nr], this.template_by_class[ts_element_class], true);
			}
		}
	}
	if(this.template_by_id)
	{
		for(var ts_element_id in this.template_by_id)
		{
			var element = document.getElementById(ts_element_id);
			if(element)
			{
				this.load_element(element, this.template_by_id[ts_element_id], true);
			}
		}
	}
	if(this.template_by_tagname)
	{
		for(var ts_element_tagname in this.template_by_tagname)
		{
			var elements = document.getElementsByTagName(ts_element_tagname);
			var element_count = elements.length;
			for(var element_nr = 0; element_nr < element_count; element_nr++)
			{
				this.load_element(elements[element_nr], this.template_by_tagname[ts_element_class], true);
			}
		}
	}

	window.testseek.load_held();

	window.testseek.add_listners();
}
/* End of init.js */

/* Start of init_css.js */
window.testseek.init_css = function(ts_srv) {
    var flagsFanta = 'https://' + ts_srv + '/images/testsites/flag_sprite.png';
	var css = [
		'.ts_product_na {display: none;}',
		'.ts_ereviews_none .ts_show_if_erev {display: none;}',
		'.ts_ereviews_have .ts_hide_if_erev {display: none;}',
		'.ts_ereviews_no_score .ts_show_if_escore {display: none;}',
		'.ts_ereviews_have_score .ts_hide_if_escore {display: none;}',
		'.ts_videos_none .ts_show_if_vrev {display: none;}',
		'.ts_videos_have .ts_hide_if_vrev {display: none;}',
		'.ts_aureviews_na .ts_show_if_aurev {display: none;}',
		'.ts_aureviews_summary_na .ts_show_if_aurev_summary {display: none;}',
		'.ts_aureviews_none .ts_show_if_aurev {display: none;}',
		'.ts_aureviews_none .ts_show_if_aurev_summary {display: none;}',
		'.ts_aureviews_have .ts_hide_if_aurev {display: none;}',
		'.ts_aureviews_have .ts_hide_if_aurev_summary {display: none;}',
		'.ts_aureviews_no_score .ts_show_if_auscore {display: none;}',
		'.ts_aureviews_have_score .ts_hide_if_auscore {display: none;}',
		'.ts_ureviews_none .ts_show_if_urev {display: none;}',
		'.ts_ureviews_have .ts_hide_if_urev {display: none;}',
		'.ts_ureviews_no_score .ts_show_if_uscore {display: none;}',
		'.ts_ureviews_have_score .ts_hide_if_uscore {display: none;}',
		'.ts_videos_none .ts_show_if_videos {display: none;}',
		'.ts_videos_have .ts_hide_if_videos {display: none;}',

		'.ts_ereviews_any_cons .ts_hide_if_cons {display: none;}',
		'.ts_ereviews_no_cons .ts_show_if_cons {display: none;}',
		'.ts_ereviews_any_pros .ts_hide_if_pros {display: none;}',
		'.ts_ereviews_no_pros .ts_show_if_pros {display: none;}',
		'.ts_ereviews_any_cons.ts_ereviews_any_pros .ts_hide_if_pros_and_cons {display: none;}',
		'.ts_ereviews_any_cons .ts_hide_if_pros_or_cons {display: none;}',
		'.ts_ereviews_any_pros .ts_hide_if_pros_or_cons {display: none;}',
		'.ts_ereviews_no_cons.ts_ereviews_no_pros .ts_show_if_pros_or_cons {display: none;}',
		'.ts_ereviews_no_cons .ts_show_if_pros_and_cons {display: none;}',
		'.ts_ereviews_no_pros .ts_show_if_pros_and_cons {display: none;}',
		'.ts_ereviews_any_award .ts_hide_if_awards {display: none;}',
		'.ts_ereviews_no_award .ts_show_if_awards {display: none;}',
		'.ts_have_score .ts_hide_if_score {display: none;}',
		'.ts_no_score .ts_show_if_score {display: none;}',
		'.ts_have_award .ts_hide_if_award {display: none;}',
		'.ts_no_award .ts_show_if_award {display: none;}',
		'.ts_have_ts_award .ts_hide_if_ts_award {display: none;}',
		'.ts_no_ts_award .ts_show_if_ts_award {display: none;}',
		'.ts_have_author .ts_hide_if_author {display: none;}',
		'.ts_no_author .ts_show_if_author {display: none;}',
		'.ts_have_date .ts_hide_if_date {display: none;}',
		'.ts_no_date .ts_show_if_date {display: none;}',
		'.ts_have_comment .ts_hide_if_comment {display: none;}',
		'.ts_no_comment .ts_show_if_comment {display: none;}',
		'.ts_comment_have_parts .ts_hide_if_comment_parts {display: none;}',
		'.ts_comment_no_parts .ts_show_if_comment_parts {display: none;}',
		'.ts_comment_have_good .ts_hide_if_good_comment {display: none;}',
		'.ts_comment_no_good .ts_show_if_good_comment {display: none;}',
		'.ts_comment_have_bad .ts_hide_if_bad_comment {display: none;}',
		'.ts_comment_no_bad .ts_show_if_bad_comment {display: none;}',
		'.ts_comment_have_bottom .ts_hide_if_bottomline {display: none;}',
		'.ts_comment_no_bottom .ts_show_if_bottomline {display: none;}',

		'.ts_aurss_no_features .ts_show_if_aurss_features {display: none;}',
		'.ts_aur_features_no_summary .ts_show_if_aurss_features_summary {display: none;}',
		'.ts_aurss_have_features .ts_hide_if_aurss_features {display: none;}',
		'.ts_aurss_no_recommend .ts_show_if_aurss_recommend {display: none;}',
		'.ts_aurss_have_recommend .ts_hide_if_aurss_recommend {display: none;}',
		'.ts_partly_loaded .ts_show_if_fully_loaded {display: none;}',
		'.ts_fully_loaded .ts_show_if_partly_loaded {display: none;}',
		'.testseek_main .pros_con_long .ts_more {display: none;}',
		'.testseek_main .pros_con_short .ts_less {display: none;}',
        '.ts_aur_no_cons .ts_show_if_aur_pros_or_cons {display: none;}',
        '.ts_aur_no_pros .ts_show_if_aur_pros_or_cons {display: none;}',
		'.testseek_main .awards_long .ts_more {display: none;}',
		'.testseek_main .awards_short .ts_less {display: none;}',
		'.testseek_main .ts_video_longlist .ts_more {display: none;}',
		'.testseek_main .ts_video_shortlist .ts_less {display: none;}',

        //v5.2
        '.ts_aurss_product_url_inactive .ts_hide_if_aurss_product_url_inactive {display: none;}',
        '.ts_stars_tmpl_hide .ts_hide_stars_if_no_aer_no_aur {display: none;}',
        '.ts_live_api_box_hide .ts_hide_entire_section_if_conditions_are_met {display: none;}',
		//v5.3.4 AER inactive links
		'.ts_aer_product_url_inactive .ts_hide_if_aer_product_url_inactive {display: none;}',

        //AURSS product links modal pop-over styles v5.2
        '.testseek_main .ts_aurss_product_urls_modal {opacity: 0; position: absolute; z-index: -1; right: 0px; top: 500px; max-width: 300px; min-width: 250px; font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;    font-size: 14px; font-style: normal;    font-weight: 400;    line-height: 1.42857143;    text-align: left;    text-align: start;    text-decoration: none;    text-shadow: none;    text-transform: none;    letter-spacing: normal;    word-break: normal;    word-spacing: normal;    word-wrap: normal;    white-space: normal;    background-color: #fff;    border: 1px solid #ccc;  border-radius: 6px;    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,.2);    box-shadow: 0 5px 10px rgba(0,0,0,.2);    line-break: auto;}',
        '.testseek_main .ts_aurss_product_urls_modal_content UL {list-style-type: none;}',
        '.testseek_main .ts_aurss_product_urls_modal_hide {display: none;}',
        '.testseek_main .ts_aurss_product_urls_modal_content {padding: 15px;    max-height: 300px;  overflow: auto;}',
        '.testseek_main .ts_aurss_product_urls_modal_content > .ts_wtb_arrow {top: 15%;    left: -11px;    margin-top: -11px;    border-right-color: rgba(0,0,0,.25)!important;    border-left-width: 0!important;    border-width: 11px;}',
        '.testseek_main .ts_aurss_product_urls_modal_content > .ts_wtb_arrow, .ts_aurss_product_urls_modal_content > .ts_wtb_arrow:after {position: absolute;    display: block;    width: 0;    height: 0;    border-color: transparent;    border-style: solid;}',
        '.testseek_main .ts_aurss_product_urls_modal_content > .ts_wtb_arrow:after {content: "";    border-left-width: 0;    border-width: 10px;    bottom: -10px;    border-right-color: #fff;    border-left-width: 0;    left:1px;}',

        '.testseek_main .ts_aurss_product_urls_modal_content > .ts_wtb_close {position: absolute;top: 5px;right: 15px;transition: all 200ms;font-size: 30px;font-weight: bold;text-decoration: none;color: #333;}',
        '.testseek_main .ts_aurss_product_urls_modal_content > .ts_wtb_close:hover {color: #06D85F;}',

		//Absolutely required for AURSS product modals to work! //test box model below with: background-color: #ffcc33;
		'.testseek_main .ts_aurss {position: relative;}',


		'.ts_popup .ts_hide_if_popup {display: none;}',
		'.testseek_main .ts_show_if_popup {display: none;}',
		'.ts_popup.testseek_main .ts_show_if_popup, .ts_popup .testseek_main .ts_show_if_popup {display: block;}',

		'.testseek_main .ts_video_type_hide, .testseek_main .ts_video_language_hide, .testseek_main .ts_video_quality_hide {display: none;}',
		'.ts_stars_template .ts_stars {font-size: 24px; position: absolute; display: block; top: 0px;}',
		'.ts_stars_template .ts_stars_rating > SPAN > I {font-size: 22px; letter-spacing: -2px;}',
		'.ts_ereviews_have_score .ts_stars.ts_hide_if_escore {display: none;}',
		'.ts_ereviews_no_score .ts_stars.ts_show_if_escore {display: none;}',

		'.ts_star1, .ts_star2, .ts_star3, .ts_star4, .ts_star5, .ts_star_half {display: none;}',
		'.score_10 .ts_star_half, .score_30 .ts_star_half, .score_50 .ts_star_half, .score_70 .ts_star_half, .score_90 .ts_star_half {display: inline;}',
		'.score_20 .ts_star1, .score_30 .ts_star1, .score_40 .ts_star1, .score_50 .ts_star1, .score_60 .ts_star1, .score_70 .ts_star1, .score_80 .ts_star1, .score_90 .ts_star1, .score_100 .ts_star1 {display: inline;}',
		'.score_40 .ts_star2, .score_50 .ts_star2, .score_60 .ts_star2, .score_70 .ts_star2, .score_80 .ts_star2, .score_90 .ts_star2, .score_100 .ts_star2 {display: inline;}',
		'.score_60 .ts_star3, .score_70 .ts_star3, .score_80 .ts_star3, .score_90 .ts_star3, .score_100 .ts_star3 {display: inline;}',
		'.score_80 .ts_star4, .score_90 .ts_star4, .score_100 .ts_star4 {display: inline;}',
		'.score_100 .ts_star5 {display: inline;}',
		'.score_10 .ts_star_e1, .score_20 .ts_star_e1, .score_30 .ts_star_e1, .score_40 .ts_star_e1, .score_50 .ts_star_e1, .score_60 .ts_star_e1, .score_70 .ts_star_e1, .score_80 .ts_star_e1, .score_90 .ts_star_e1, .score_100 .ts_star_e1 {display: none;}',
		'.score_30 .ts_star_e2, .score_40 .ts_star_e2, .score_50 .ts_star_e2, .score_60 .ts_star_e2, .score_70 .ts_star_e2, .score_80 .ts_star_e2, .score_90 .ts_star_e2, .score_100 .ts_star_e2 {display: none;}',
		'.score_50 .ts_star_e3, .score_60 .ts_star_e3, .score_70 .ts_star_e3, .score_80 .ts_star_e3, .score_90 .ts_star_e3, .score_100 .ts_star_e3 {display: none;}',
		'.score_70 .ts_star_e4, .score_80 .ts_star_e4, .score_90 .ts_star_e4, .score_100 .ts_star_e4 {display: none;}',
		'.score_90 .ts_star_e5, .score_100 .ts_star_e5 {display: none;}',
		'.ts_stars_rating {color: #ffa500;}',

		'.testseek_main',
		'{',
		'	box-sizing: border-box;',
		'	padding: 0;',
		'	margin: 0;',
		'	font-family: "wf_SegoeUI","Segoe UI","Segoe","Segoe WP","Tahoma","Verdana","Arial","sans-serif";',
		'	font-size: 16px;',
		'	color: #6a6a6a;',
		'}',
		'',
		'.testseek_main *',
		'{',
		'	margin: 0;',
		'	padding: 0;',
		'	vertical-align: top;',
		'	transition-delay: 0s;',
		'	transition-duration: 1s;',
		'	transition-property: all;',
		'	transition-timing-function: ease;',
		'}',
		'',
		'.testseek_main DIV',
		'{',
		'	display: block;',
		'	float: left;',
		'	width: auto;',
		'	border: none;',
		'	line-height: 19px;',
		'	box-sizing: border-box;',
		'}',
		'.testseek_main P',
		'{',
		'	line-height: 19px;',
		'	font-size: 16px;',
		'}',
		'',
		'.testseek_main IFRAME.ts_iframe, .testseek_main DIV.ts_iframe',
		'{',
		'	width: 100%;',
		'	float: left;',
		'	border: none;',
		'}',
		'',
		'.ts_inside_iframe',
		'{',
		'	overflow: hidden;',
		'}',
		'',
		'.testseek_main DIV.l, .testseek_main IFRAME.ts_iframe.l',
		'{',
		'	clear: both;',
		'	width: 100%;',
		'	margin-top: 10px;',
		'}',
		'',
		'.testseek_main DIV.l > DIV.l:first-child',
		'{',
		'	margin-top: 0;',
		'}',
		'',
		'.testseek_main DIV.l.r, .testseek_main IFRAME.ts_iframe.l.r',
		'{',
		'	border-top: 1px solid rgb(221, 221, 221);',
		'	padding-top: 25px;',
		'}',
		'',
		'.testseek_main SPAN.y',
		'{',
		'	color: yellow;',
		'}',
		'.testseek_main SPAN.s',
		'{',
		'	color: #ecc508;',
		'	font-size: x-large;',
		'	text-shadow: black 1px 1px 1px;',
		'	margin-top: -8px;',
		'}',
		'',
		'.testseek_main SPAN.r',
		'{',
		'	color: #ef5252;',
		'}',
		'',
		'.testseek_main SPAN.g',
		'{',
		'	color: #5dab39;',
		'}',
		'',
		'.testseek_main SPAN.thumb',
		'{',
		'	font-weight: bold;',
		'	font-size: x-large;',
		'}',
		'',
		'.testseek_main .ts_er_top_header',
		'{',
		'	line-height: 28px;',
		'	font-size: 28px;',
		'	margin-bottom: 20px;',
		'}',
		'.ts_popup .ts_er_top_header',
		'{',
		'	margin-right: 50px;',
		'}',
		'',
		'.testseek_main .ts_aur_top_header',
		'{',
		'	font-size: 28px;',
		'	margin-bottom: 20px;',
		'	line-height: 28px;',
		'}',
		'.testseek_main .videos_top_header',
		'{',
		'	font-size: 28px;',
		'	margin-bottom: 20px;',
		'}',
		'',
		'.testseek_main .aur_rate_header',
		'{',
		'	margin-bottom: 10px;',
		'}',
		'',
		'.testseek_main .er_dist_header',
		'{',
		'	margin-bottom: 10px;',
		'}',
		'',
		'.testseek_main .aur_dist_header',
		'{',
		'	margin-bottom: 10px;',
		'}',
		'',
		'.testseek_main .aur_feat_header',
		'{',
		'	margin: 20px 0px 10px 0px',
		'}',
		'',
		'.testseek_main .er_proscons_header',
		'{',
		'	margin-bottom: 0px;',
		'}',
		'',
		'.testseek_main .aur_proscons_header',
		'{',
		'	margin: 20px 0px 10px 0px',
		'}',
		'',
		'.testseek_main .er_list_header',
		'{',
		'	margin-bottom: 10px;',
		'}',
		'',
		'.testseek_main .er_awards_header',
		'{',
		'	margin-bottom: 10px;',
		'}',
		'',
		'.testseek_main .ts_rate',
		'{',
		'	width: 200px;',
		'	text-align: center;',
		'	padding-top: 30px;',
		'	padding-bottom: 30px;',
		'}',
		'',
		'.testseek_main .ts_200n',
		'{',
		'	width: 100%;',
		'	width: calc(100% - 205px);',
		'}',
		'',
		'.testseek_main .ts_edist TABLE',
		'{',
		'	table-layout: fixed;',
		'	width: 100%;',
		'}',
		'',
		'.testseek_main .ts_edist TR, .testseek_main .ts_edist TR *',
		'{',
		'	height: 20px;',
		'}',
		'',
		'.testseek_main .ts_edist TH',
		'{',
		'	text-align: left;',
		'	font-weight: normal;',
		'}',
		'',
		'.testseek_main .ts_edist TD',
		'{',
		'	text-align: right;',
		'	line-height: 26px;',
		'}',
		'.testseek_main .ts_edist SPAN',
		'{',
		'	display: inline-block;',
		'}',
		'',
		'.testseek_main .ts_bar_bg',
		'{',
		'	background: #e5e5e5;',
		'	text-align: left;',
		'	overflow: hidden;',
		'	height: 20px;',
		'	width: 100%;',
		'}',
		'',
		'.testseek_main .ts_bar_bg SPAN',
		'{',
		'	height: 18px;',
		'	width: 100%;',
		'	box-shadow: gray 1px 1px 1px;',
		'}',
		'',
		'.testseek_main .ts_bar_bg SPAN.bar_5s',
		'{',
		'	background: #5dab39;',
		'}',
		'',
		'.testseek_main .ts_bar_bg SPAN.bar_4s',
		'{',
		'	background: #87d962;',
		'}',
		'',
		'.testseek_main .ts_bar_bg SPAN.bar_3s',
		'{',
		'	background: #f1bf70;',
		'}',
		'',
		'.testseek_main .ts_bar_bg SPAN.bar_2s',
		'{',
		'	background: #fba7a7;',
		'}',
		'',
		'.testseek_main .ts_bar_bg SPAN.bar_1s',
		'{',
		'	background: #de5a5a;',
		'}',
		'',
		'.testseek_main .pros_icon, .testseek_main .cons_icon, .testseek_main .bottomline_icon',
		'{',
		'	float: left;',
		'	border-right: solid #e5e5e5 1px;',
		'	border-bottom: solid #e5e5e5 1px;',
		'	color: white;',
		'	font-size: 18px;',
		'	vertical-align: middle;',
		'	text-align: center;',
		'	width: 21px;',
		'	height: 21px;',
		'	line-height: 1em;',
		'	font-weight: bold;',
		'	margin-right: 10px;',
		'	margin-top: 2px;',
		'}',
		'',
		'.testseek_main .pros_icon',
		'{',
		'	background: #5dab39;',
		'}',
		'.testseek_main .cons_icon',
		'{',
		'	background: #ef5252;',
		'}',
		'.testseek_main .bottomline_icon',
		'{',
		'	background: #3779bd;',
		'	font-size: 18px;',
		'}',
		'',
		'.testseek_main .pros_con_short UL',
		'{',
		'	overflow: hidden;',
		'	height: 1.3em;',
		'}',
		'',
		'.testseek_main .pros_con_short LI',
		'{',
		'	display: inline-block;',
		'	float: left;',
		'}',
		'',
		'.testseek_main .pros_con_short LI:after',
		'{',
		'	content: ", ";',
		'	margin-right: 2px;',
		'}',
		'.testseek_main .pros_con_short LI:last-child:after',
		'{',
		'	content: "";',
		'	margin-right: 0px;',
		'}',
		'.testseek_main .pros_con_long .pros_icon, .testseek_main .pros_con_long .cons_icon',
		'{',
		'	display: none;',
		'}',
		'.testseek_main .pros_con ul { list-style-type: none; }',
		'.testseek_main .pros_con_long .ts_e_summary_pros_loop LI:before,',
		'.testseek_main .pros_con_long .ts_aur_summary_pros_loop LI:before',
		'{',
		'	content: " + ";',
		'	background: #5dab39;',
		'}',
		'.testseek_main .pros_con_long .ts_e_summary_cons_loop LI:before,',
		'.testseek_main .pros_con_long .ts_aur_summary_cons_loop LI:before',
		'{',
		'	content: " - ";',
		'	background: #ef5252;',
		'}',
		'.testseek_main .pros_con_long .ts_e_summary_pros_loop LI:before,',
		'.testseek_main .pros_con_long .ts_aur_summary_pros_loop LI:before,',
		'.testseek_main .pros_con_long .ts_e_summary_cons_loop LI:before,',
		'.testseek_main .pros_con_long .ts_aur_summary_cons_loop LI:before',
		'{',
		'	display: inline-block;',
		'	width: 21px;',
		'	height: 21px;',
		'	line-height: 1em;',
		'	margin-right: 10px;',
		'	margin-bottom: 10px;',
		'	margin-top: 2px;',
		'	font-size: 18px;',
		'	font-weight: bold;',
		'	text-align: center;',
		'	vertical-align: middle;',
		'	color: white;',
		'	border-right: solid #e5e5e5 1px;',
		'	border-bottom: solid #e5e5e5 1px;',
		'}',
		'',
		'.testseek_main .more_link',
		'{',
		'	display: inline-block;',
		'	float: right;',
		'}',
		'',
		'.testseek_main .more_link A',
		'{',
		'	color: gray;',
		'}',
		'',
		'.testseek_main .awards_short .awards',
		'{',
		'	overflow: hidden;',
		'	height: 123px;',
		'}',
		'.testseek_main .awards DIV',
		'{',
		'	float: left;',
		'	height: 120px;',
		'	line-height: 120px;',
		'	max-width: 200px;',
		'	margin-right: 5px;',
		'	margin-bottom: 5px;',
		'}',
		'.testseek_main .awards IMG',
		'{',
		'	max-height: 120px;',
		'	max-width: 120px;',
		'	vertical-align: middle;',
		'	margin-right: 15px;',
		'}',
		'',
		'.testseek_main .ts_award_loop IMG[alt*="cnet.co.uk award"], IMG[alt*="cnet.com award"], IMG[alt*="cnet.com.au award"], IMG[alt*="cnetfrance.fr award"], IMG[alt*="pcmag-mideast.com award"], IMG[alt*="pcmag.com award"], IMG[alt*="pcmagazine.ru award"] { display: none; }',
                '.testseek_main .ts_e_review IMG[alt*="cnet.co.uk award"], IMG[alt*="cnet.com award"], IMG[alt*="cnet.com.au award"], IMG[alt*="cnetfrance.fr award"], IMG[alt*="pcmag-mideast.com award"], IMG[alt*="pcmag.com award"], IMG[alt*="pcmagazine.ru award"] { display: none; }',
		'.testseek_main IMG.ts_award',
		'{',
		'	max-height: 120px;',
		'	max-width:  120px;',
		'	margin: 0px 0px 0px 10px;',
		'}',
		'',
		'.testseek_main .flag',
		'{',
		'	width: 20px;',
		'	height: 13px;',
        '   background: url("' + flagsFanta + '");',
		'	background-repeat: no-repeat;',
		'	vertical-align: middle;',
		'	display: inline-block;',
		'}',
		'',
		'.testseek_main .er_publisher_flag',
		'{',
		'	vertical-align: middle;',
		'	margin-right: -20px;',
		'	margin-left: 5px;',
		'}',
		'',
		'.testseek_main .ext_link_ts',
		'{',
		'	vertical-align: middle;',
		'	color: #337ab7;',
		'	text-decoration: none;',
		'}',
		'.testseek_main A.ext_link_ts:hover',
		'{',
		'	color: #23527c;',
		'}',
		'',
		'.testseek_main .er_publisher_logo',
		'{',
		'	margin-top: 5px;',
		'}',
		'',
		'.testseek_main .er_load_more',
		'{',
		'	font-size: 28px;',
		'	margin-bottom: 20px;',
		'}',
		'',
		'.testseek_main .ts_frate LI',
		'{',
		'	display: inline-block;',
		'	float: left;',
		'	margin-right: 10px;',
		'}',
		'.testseek_main .ts_frate LI SPAN',
		'{',
		'	width: 140px;',
		'}',
		'',
		'.testseek_main .ext_link_aur',
		'{',
		'	vertical-align: middle;',
		'	font-size: 18px;',
		'}',
		'',
		'.testseek_main .aurss_flag',
		'{',
		'	vertical-align: middle;',
		'}',
		'',
		'.testseek_main .aurss_logo',
		'{',
		'	margin: 0px 25px 0px 0px;',
		'}',
		'',
		'.testseek_main .aur_sumlist_rate_header',
		'{',
		'	margin-bottom: 10px;',
		'}',
		'',
		'.testseek_main .aur_sumlist_dist_header',
		'{',
		'	margin-bottom: 10px;',
		'}',
		'',
		'.testseek_main .aur_sumlist_feat_header',
		'{',
		'	margin: 20px 0px 10px 0px',
		'}',
		'',
		'.testseek_main .aur_sumlist_proscons_header',
		'{',
		'	margin: 20px 0px 10px 0px',
		'}',
		'',
		'.ts_aurss_feature_loop LI, .ts_aur_summary_feature_loop LI',
		'{',
		'	margin-bottom: 4px;',
		'	text-align: right;',
		'}',
		'',
		'.testseek_main .aur_sumlist_rec_pie',
		'{',
		'	margin: 15px 30px 0px 0px;',
		'}',
		'',
		'.testseek_main .aur_sumlist_rec_pie_explain',
		'{',
		'	margin: 23px 0px 13px 0px;',
		'}',
		'',
		'.testseek_main .video_voting',
		'{',
		'	margin: 15px 0px 0px 0px;',
		'}',
		'',
		'.testseek_main .video_filters',
		'{',
		'	margin: 15px 0px 0px 0px;',
		'	border: 0px;',
		'}',
		'',
		'.testseek_main .ts_video_loop',
		'{',
		'	margin: 15px 0px 0px 0px;',
		'}',
		'',
		'.testseek_main .ts_video_preivew',
		'{',
		'	max-width: 100%;',
		'}',
		'',
		'.testseek_main .ts_vid_image',
		'{',
		'	position: relative;',
		'	width: 200px;',
		'	height: 150px;',
		'	margin: 0px 15px 15px 0px;',

		'}',
		'',
		'.testseek_main .ts_vid_image > *',
		'{',
		'	position: absolute; top: 0px; left: 0px;',
		'}',
		'',
		'.testseek_main .ts_vid_image > P',
		'{',
		'	text-align: center;',
		'	vertical-align: middle;',
		'	width: 200px;',
		'	height: 150px;',
		'	line-height: 150px;',
		'	font-size: 22px;',
		'	font-weight: 500',
		'	text-shadow: 0px 0px 2px black;',
		'	color: white;',
		'}',
		'',
		'.testseek_main .ts_vid_tags > SPAN',
		'{',
		'	display: block;',
		'	margin-top: 4px;',
		'	padding: 0px 4px 0px 4px;',
		'}',
		'',
		'.testseek_main .ts_vid_tags .ts_type_tag',
		'{',
		'	background-color: #6b6b6b;',
		'	color: white;',
		'}',
		'',
		'.testseek_main .ts_vid_tags .ts_lang_tag',
		'{',
		'	background-color: #df4fd7;',
		'	color: white;',
		'}',
		'',
		'.testseek_main .ts_vid_tags .ts_video_quality',
		'{',
		'	background-color: #6e53ed;',
		'	color: white;',
		'}',
		'.testseek_main .ts_video_quality_ .ts_video_quality {display: none;}',
		'',
		'.testseek_main .ts_video_shortlist .ts_video_loop',
		'{',
		'	overflow: hidden;',
		'	max-height: 150px;',
		'}',
		'.testseek_main .ts_video_longlist .ts_video_loop',
		'{',
		'	max-height: none;',
		'}',
		'.testseek_main .ts_video_shortlist.ts_video_2r .ts_video_loop { max-height: 315px;}',
		'.testseek_main .ts_video_shortlist.ts_video_3r .ts_video_loop { max-height: 480px;}',
		'.testseek_main .ts_video_shortlist.ts_video_5r .ts_video_loop { max-height: 810px;}',
		'',
		'.testseek_main .ts_no_score .ts_beside_score',
		'{',
		'	width: 100%;',
		'}',
		'.testseek_main .ts_have_score .ts_beside_score',
		'{',
		'	width: calc(100% - 115px);',
		'}',
		'.testseek_main .l .ts_er_comments',
		'{',
		'	margin-left: 10px;',
		'}',
		'',
		'#ts_popup',
		'{',
		'	position: absolute;',
		'	top: 100px;',
		'	left: 0px;',
		'	right: 0px;',
		'	bottom: 0px;',
		'	min-height: 100%;',
		'	width: 100%;',
		'	z-index: 11147;',
		'}',
		'',
		'#ts_popup > #ts_popup_child',
		'{',
		'	position: relative;',
		'	width: calc(100%-20px);',
		'	max-width: 1000px;',
		'	background: white;',
		'	border: solid #66C 2px;',
		'	border-radius: 10px;',
		'	padding: 35px;',
		'	margin-top: 10px;',
		'	margin-left: auto;',
		'	margin-right: auto;',
		'	margin-bottom: 20px;',
		'}',
		'',
		'#ts_popup > #ts_popup_bg',
		'{',
		'	position: fixed;',
		'	top: 0px;',
		'	left: 0px;',
		'	right: 0px;',
		'	bottom: 0px;',
		'	background: rgba(0, 0, 0, 0.5);',
		'}',
		'',
		'#ts_popup .ts_close_popup',
		'{',
		'	position: relative;',
		'	top: 15px;',
		'	width: 30px;',
		'	float: right;',
		'   border: solid #e5e5e5 2px;',
		'	border-radius: 5px;',
		'	text-align: center;',
		'	background: #5074fb;',
		'	color: white;',
		'}',
		'',
		'#ts_popup .ts_close_popup:hoover',
		'{',
		'	background: #969696;',
		'}',
		'',
		'.ts_poweredby_img',
		'{',
		'	border: solid 1px;',
		'	border-color: #ccc gray gray #ccc;',
		'	border-radius: 5px;',
		'	width: 120px;',
		'	height: auto;',
		'	display: none;',
		'	margin-top: 20px;',
		'}',
		'',
		'.ts_ereviews_have .ts_poweredby_img, .ts_videos_have .ts_poweredby_img, .ts_aureviews_have .ts_poweredby_img',
		'{',
		'	display: block;',
		'}',
		'',
		'.testseek_main *[onclick] {cursor: pointer;}',
		'',
		'@media all and (max-width: 600px)',
		'{',
		'	.testseek_main .ts_rate',
		'	{',
		'		width: 130px;',
		'	}',
		'	.testseek_main .ts_200n',
		'	{',
		'		width: calc(100% - 135px);',
		'	}',
		'}',
		'@media all and (max-width: 400px)',
		'{',
		'	.testseek_main .ts_200n,',
		'	.testseek_main .ts_have_score .ts_beside_score',
		'	{',
		'		width: 100%;',
		'	}',
		'',
		'	.ts_main_template .ts_rate,',
		'	.ts_main_template .ts_award',
		'	{',
		'		float: none;',
		'		margin: auto;',
		'		text-align: center;',
		'	}',
		'',
		'	#ts_popup',
		'	{',
		'		top: 50px;',
		'		left: 0px;',
		'		right: 0px;',
		'		width: 100%;',
		'		border: none;',
		'	}',
		'}',
	];

	var ts_css = document.getElementById('ts_css');
	if(ts_css)
	{
		ts_css.textContent = css.join("\n");
	}
	else
	{
		ts_css = document.createElement('style');
		ts_css.id = 'ts_css';
		ts_css.type = 'text/css';
		ts_css.textContent = css.join("\n");
		document.head.appendChild(ts_css);
	}
}
/* End of init_css.js */

/* Start of init_font.js */
window.testseek.init_font = function() {
	var font_element;
	font_element = document.getElementById('testseek_font');
	if(font_element)
	{
		font_element.remove();
	}

	if(!window.testseek.icon_library_url)
	{
		return true;
	}

	font_element = document.createElement('link');
	font_element.id = 'testseek_font';
	font_element.type = 'text/css';
	font_element.rel = 'stylesheet';
	font_element.href = window.testseek.icon_library_url;

	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(font_element, s);
}
/* End of init_font.js */

/* Start of inline_iframe_init.js */
/**
 * Load content into src-less iframes
 *
 * @depends window.testseek.iframe_naming_count
 **/

window.testseek.inline_iframe_init = function() {
	// Make sure we have a iframe name counter
	if(!window.testseek.iframe_naming_count)
	{
		window.testseek.iframe_naming_count = 0;
	}

	// Fetch a list of all iframes on the page
	var iframes = document.getElementsByTagName('iframe');
	var iframe_count = iframes.length;

	// loop all iframes on the page
	for(var f_nr = 0; f_nr < iframe_count; f_nr++)
	{
		var iframe = iframes[f_nr];

		// boolean flag for remember if we handled/done somthing with the current iframe
		var updated = false;

		// if not already loaded
		if(!iframe.ts_html)
		{
			// and it has a inline content
			if(iframe.innerHTML.length)
			{
				// Store inline content for later use
				iframe.ts_html = iframe.innerHTML;
				iframe.ts_init_classes = iframe.className;
			}
			else
			{
				// skip if no inline content
				continue;
			}
		}

		// is this iframe marked as ts_inline_html
		if(iframe.classList.contains('ts_inline_html'))
		{
			// copy the current content (innerHTML content, not contentDocument)
			var content = iframe.ts_html;

			// skip if no content
			if(!content.length)
			{
				continue;
			}

			// check if content don't have html = the html is encoded
			if(content.indexOf('<') < 0)
			{
				// create a textarea to use as decoder
				var decoder = document.createElement('textarea');

				// set the encoded content as the decoders html-value
				decoder.innerHTML = content;

				// check if the decoders content don't have html = the html was double encoded
				if(decoder.value.indexOf('<') < 0)
				{
					// set the decoded value as the html value of the decoder
					decoder.innerHTML = decoder.value;
				}

				// replace the content with the decode value (or double decoded)
				content = decoder.value;
			}

			// size of body dosn't work in all browser, so using first child, by wraping in in an extra div
			content = '<div class="' + iframe.className + '">' + content + '</div>';

			// set the new content as the html inside the iframe, inside the body-tag (contentDocument, not just innerHTML)
			iframe.contentDocument.body.innerHTML = content;

			// add the testseek_main class to the body element
			iframe.contentDocument.body.classList.add('testseek_main');
			iframe.contentDocument.body.classList.add('ts_inside_iframe');

			// remove the todo-class, from the iframe, so we don't redo it
			iframe.classList.remove('ts_inline_html');

			// remove the old content (innerHTML, not contentDocument)
			iframe.innerHTML = "";

			// flag as updated
			updated = true;
		}

		if(iframe.classList.contains('ts_inline_full_html'))
		{
			// copy the current content (innerHTML content, not contentDocument)
			var content = iframe.ts_html;

			// skip if no content
			if(!content.length)
			{
				continue;
			}

			// check if content don't have html = the html is encoded
			if(content.indexOf('<') < 0)
			{
				// create a textarea to use as decoder
				var decoder = document.createElement('textarea');

				// set the encoded content as the decoders html-value
				decoder.innerHTML = content;

				// check if the decoders content don't have html = the html was double encoded
				if(decoder.value.indexOf('<') < 0)
				{
					// set the decoded value as the html value of the decoder
					decoder.innerHTML = decoder.value;
				}

				// replace the content with the decode value (or double decoded)
				content = decoder.value;
			}

			// set the new content as the html inside the iframe, inside the html-tag (contentDocument, not just innerHTML)
			iframe.contentDocument.body.parentNode.innerHTML = content;

			// remove the todo-class, from the iframe, so we don't redo it
			iframe.classList.remove('ts_inline_full_html');

			// remove the old content (innerHTML, not contentDocument)
			iframe.innerHTML = "";

			// flag as updated
			updated = true;
		}

		// common part for updated iframes
		if(updated)
		{
			// add the ts_iframe class, to the iframe, so we can find it later
			iframe.classList.add('ts_iframe');

			// We need an id, if we don't have one
			if(!iframe.id)
			{
				// name ifram using our name counter
				iframe.id = "ts_iframe_autoname_" + window.testseek.iframe_naming_count;

				// increase counter, to avoid duplicate names
				window.testseek.iframe_naming_count++;
			}

			// TODO keep one
			// store name inside iframe, so it kan use it when asking for a resize
			iframe.name = iframe.id;
			iframe.contentDocument.name = iframe.id;
			iframe.contentDocument.body.name = iframe.id;
			iframe.contentWindow.name = iframe.id;

			// find the css element
			var ts_css = document.getElementById('ts_css');

			// clone the css element
			var iframe_css = ts_css.cloneNode();
			iframe_css.innerHTML = ts_css.innerHTML;

			// put cloned css inside iframe
			iframe.contentDocument.head.appendChild(iframe_css);

			// Auto adjust size when iframe done loading
			iframe.onload = function(event) {
				if(event.target.contentDocument.body.firstChild)
				{
					event.target.height = (10 + event.target.contentDocument.body.firstChild.offsetHeight) + 'px';
				}
			};

			// Auto adjust size now, as onload may not be triggered
			iframe.height = (10 + iframe.contentDocument.body.firstChild.offsetHeight) + 'px';

			// share the testseek javascript object
			iframe.contentDocument.testseek = window.testseek;
		}
	}
}
/* End of inline_iframe_init.js */

/* Start of listners.js */
window.testseek.add_listners = function()
{
	// run only once
	if(!window.testseek.liseners_added)
	{
		window.testseek.liseners_added = true;

		if(window.addEventListener)
		{
			// window.addEventListener("message", window.testseek.handle_message, false);
			window.addEventListener("resize", window.testseek.resize_iframes, false);
			//window.addEventListener("resize", window.testseek.aurss_modal_urls_onresize, false);
			//window.addEventListener("click", window.testseek.aurss_modal_urls_onclick, false);
		}
		else
		{
			// window.attachEvent("onmessage", window.testseek.handle_message);
			window.attachEvent("onresize", window.testseek.resize_iframes);
			//window.attachEvent("onresize", window.testseek.aurss_modal_urls_onresize);
			//window.attachEvent("onclick", window.testseek.aurss_modal_urls_onclick);
		}

		if(this.auto_resize_class)
		{
			var elements = document.getElementsByClassName(this.auto_resize_class);
			var element_count = elements.length;
			for(var element_nr = 0; element_nr < element_count; element_nr++)
			{
				if(window.addEventListener)
				{
					elements[element_nr].addEventListener("click", window.testseek.delayed_resize_iframes, false);
				}
				else
				{
					elements[element_nr].attachEvent("onclick", window.testseek.delayed_resize_iframes);
				}
			}
		}
	}
}

window.testseek.remove_listners = function()
{
	if(window.addEventListener)
	{
		// window.removeEventListener("message", window.testseek.handle_message, false);
		window.removeEventListener("resize", window.testseek.resize_iframes, false);
		//window.removeEventListener("resize", window.testseek.aurss_modal_urls_onresize, false);
        //window.removeEventListener("click", window.testseek.aurss_modal_urls_onclick, false);
	}
	else
	{
		// window.detachEvent("onmessage", window.testseek.handle_message);
		window.detachEvent("onresize", window.testseek.resize_iframes);
		//window.detachEvent("onresize", window.testseek.aurss_modal_urls_onresize);
        //window.detachEvent("onclick", window.testseek.aurss_modal_urls_onclick);
	}

	if(this.auto_resize_class)
	{
		var elements = document.getElementsByClassName(this.auto_resize_class);
		var element_count = elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			if(window.addEventListener)
			{
				window.removeEventListener("click", window.testseek.delayed_resize_iframes, false);
			}
			else
			{
				window.detachEvent("onclick", window.testseek.delayed_resize_iframes);
			}
		}
	}

	window.testseek.liseners_added = false;
}
/* End of listners.js */

/* Start of load_element.js */
/**
 * Try to apply template to an element, or fetch missing information
 *
 * @param element HTMLElement object to apply template to
 * @param template_name String name of the template to use, should be found in testseek.template[template_name]
 * @param hold boolean Don't send ajax if missing, (collect more missing first, call load_held later)
 *
 * @depends parseQuery, render_element, pending, load_held, data(pids, mpns, icecats)
 **/

window.testseek.load_element = function(element, template_name, hold)
{
	// temporarye variable to dump stuff, before deciding to use it or not
	var test = false;

	// object that collect the serach-parameters
	var search = {};

	// count of collected serach-parameters
	var parameter_count = 0;

	// variable to store the testseek-product-id if avaible
	var ts_id = false;

	// not found yet
	if(!ts_id)
	{
		// try to fetch the attribute data-ts-id: testseek-product-id
		test = element.getAttribute('data-ts-id');
		if(test)
		{
			// store as search parameter
			search.id = test;

			// count as search-paramter
			parameter_count++;

			// remember the id
			ts_id = test;
		}
	}

	// not found yet
	if(!ts_id)
	{
		// try to fetch the attribute data-ts-pid: Partner product id
		test = element.getAttribute('data-ts-pid');
		if(test)
		{
			// store as search parameter
			search.pid = test;

			// count as search-paramter
			parameter_count++;

			// do we already know the testseek product id?
			if(window.testseek.pids[test])
			{
				// remember the id
				ts_id = window.testseek.pids[test];
			}
		}
	}

	// not found yet
	if(!ts_id)
	{
		test = element.getAttribute('data-ts-mpn');
		if(test)
		{
			// store as search parameter
			search.mpn = test;

			// count as search-paramter
			parameter_count++;

			// do we already know the testseek product id?
			if(window.testseek.mpns[test])
			{
				// remember the id
				ts_id = window.testseek.mpns[test];
			}
		}
	}

	// not found yet
	if(!ts_id)
	{
		test = element.getAttribute('data-ts-ean');
		if(test)
		{
			// store as search parameter
			search.ean = test;

			// count as search-paramter
			parameter_count++;

			// do we already know the testseek product id?
			if(window.testseek.mpns[test])
			{
				// remember the id
				ts_id = window.testseek.mpns[test];
			}
		}
	}

	// not found yet
	if(!ts_id)
	{
		test = element.getAttribute('data-ts-icecat');
		if(test)
		{
			// store as search parameter
			search.icecat = test;

			// count as search-paramter
			parameter_count++;

			// do we already know the testseek product id?
			if(window.testseek.icecats[test])
			{
				// remember the id
				ts_id = window.testseek.icecats[test];
			}
		}
	}

	// found something to use in search?
	if(parameter_count)
	{
		// Try to also metch manufacture
		test = element.getAttribute('data-ts-man');
		if(test)
		{
			// store as search parameter
			search.man = test;

			// count as search-paramter
			parameter_count++;
		}
	}
	// no parameters found
	else
	{
		// check for parametsers in href, like our old apis, if none there either
		if(!element.search)
		{
			// exit negativly
			return false;
		}

		// parse query part of href
		var query = window.testseek.parseQuery(element.search);

		// query have ts_id, testseek product id?
		if(query.ts_id)
		{
			// store as search parameter
			search.id = query.ts_id;

			// count as search-paramter
			parameter_count++;

			// remember the id
			ts_id = query.ts_id;
		}

		// query have pid, partner product id?
		if(query.ts_pid)
		{
			// store as search parameter
			search.pid = query.ts_pid;

			// count as search-paramter
			parameter_count++;

			if(window.testseek.pids[query.ts_pid])
			{
				ts_id = window.testseek.pids[query.ts_pid];
			}
		}

		// query have mpn, manufacture part number?
		if(query.ts_mpn)
		{
			// store as search parameter
			search.mpn = query.ts_mpn;

			// count as search-paramter
			parameter_count++;

			if(window.testseek.mpns[query.ts_mpn])
			{
				ts_id = window.testseek.mpns[query.ts_mpn];
			}
		}

		// query have ean, International(/European) Article Number?
		if(query.ts_ean)
		{
			// store as search parameter
			search.ean = query.ts_ean;

			// count as search-paramter
			parameter_count++;

			if(window.testseek.mpns[query.ts_ean])
			{
				ts_id = window.testseek.mpns[query.ts_ean];
			}
		}

		// query have icecatid?
		if(query.ts_icecatid)
		{
			// store as search parameter
			search.icecat = query.ts_icecatid;

			// count as search-paramter
			parameter_count++;

			if(window.testseek.icecats[query.ts_icecatid])
			{
				ts_id = window.testseek.icecats[query.ts_icecatid];
			}
		}

		// still no search parameters
		if(!parameter_count)
		{
			// exit negativly
			return false;
		}

		// do it have a manufacture parameter?
		if(query.ts_man)
		{
			// store as search parameter
			search.man = query.ts_man;

			// count as search-paramter
			parameter_count++;
		}
	}

	// Make sure we have a ts-object on the element, if missing add, and store original classname
	if(!element.ts)
	{
		element.ts = {
			"className": '' + element.className
		};
	}

	// Make sure we have a ts_id in that ts-obejct
	if(!element.ts.ts_id)
	{
		element.ts.ts_id = false;
	}

	// remember last search
	element.ts.search = search;

	// Do we know the testseek product id?
	if(ts_id)
	{
		// store it on element (lowercase)
		element.ts.ts_id = ts_id.toLowerCase();
	}
	else
	{
		// store the boolean on the element
		element.ts.ts_id = ts_id;
	}

	// if we got a new template_name (!(element.ts.template_name && !template_name))
	if(template_name || !element.ts.template_name)
	{
		// store template name on element
		element.ts.template_name = template_name;
	}

	// succed on render the element
	if(element.ts.ts_id && window.testseek.render_element(element))
	{
		// exit positivly
		return true;
	}
	// render failed, maybe we need to send an ajax first :-)
	else
	{
		// Add to list of pending elements
		window.testseek.pending.push(element);

		// load now? (or hold)
		if(!hold)
		{
			// Load all elements thats currently on hold
			window.testseek.load_held();
		}
	}
}
/* End of load_element.js */

/* Start of load_held.js */
window.testseek.load_held = function()
{
	var ts = this;
	var time = (new Date()).getTime();
	var searches = [];
	var elements = [];

	var pending = this.pending;
	this.pending = [];
	var pending_count = pending.length;
	for(var index = 0; index < pending_count; index++)
	{
//		if(!pending[index].ts.time || pending[index].ts.time < time - 5000)
//above was used to lower impact on live servers, but 5 sec wait time lowers UX score
// test		if(!pending[index].ts.time || pending[index].ts.time < time - 8000)
		if(!pending[index].ts.time || pending[index].ts.time < time - 300)
		{
			pending[index].ts.time = time;
			searches.push(pending[index].ts.search);
			elements.push(pending[index]);
		}
	}

	if(searches.length)
	{
		var ajax = new XMLHttpRequest();
		ajax.onreadystatechange = function() {
			if(ajax.readyState == /* XMLHttpRequest.DONE */ 4)
			{
				if(ajax.status == 200)
				{
					if(ajax.responseJSON)
					{
						ts.handle_respone(ajax.responseJSON, elements);
					}
					else
					{
						ts.handle_respone(ajax.responseText, elements);
					}
				}
				else if(window.testseek.verbose)
				{
					console.log(ajax.status);
					console.log(ajax);
				}
			}
		};

		ajax.open("POST", window.testseek.search_url, true);
		ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
		var parameters = "erc=" + parseInt(window.testseek.er_count);
		parameters += "&vrc=500";
		if(window.testseek.filters.er_lang)
		{
			parameters += "&er_lang=" + encodeURIComponent(window.testseek.filters.er_lang);
		}
		if(window.testseek.filters.er_have_score)
		{
			parameters += "&er_have_score=" + parseInt(window.testseek.filters.er_have_score);
		}
		if(window.testseek.filters.er_min_score)
		{
			parameters += "&er_min_score=" + parseFloat(window.testseek.filters.er_min_score);
		}
		if(window.testseek.filters.er_sort)
		{
			parameters += "&er_sort=" + encodeURIComponent(window.testseek.filters.er_sort);
		}
		if(window.testseek.filters.aur_sort)
		{
			parameters += "&aur_sort=" + encodeURIComponent(window.testseek.filters.aur_sort);
		}
		if(window.testseek.filters.filter_aurss) //Nemanja add-on for v5.2
		{
			parameters += "&filter_aurss=" + encodeURIComponent(window.testseek.filters.filter_aurss);
		}
		if(window.testseek.filters.v_sort)
		{
			parameters += "&v_sort=" + encodeURIComponent(window.testseek.filters.v_sort);
		}
		if(window.testseek.show)
		{
			parameters += "&show=" + encodeURIComponent(window.testseek.show.join(','));
		}
		parameters += "&json=" + encodeURIComponent(JSON.stringify(searches));
		ajax.send(parameters);
	}
}
/* End of load_held.js */

/* Start of load_more_aur.js */
/**
 * Load and extend a AUreview-loop with more content
 *
 * @param loop_base HTMLElement the element to extend, using its .ts.template
 * @param count int number of reviews to extend it with
 *
 * @depends search_url, handle_respone, extend_er
 **/

window.testseek.load_more_aur = function(loop_base, count)
{
	//console.log('davajce', loop_base, count, 'cekalica', loop_base.pending); //return;
	// if there is more reviews pending to be loaded
	if (loop_base.pending.length > 0)
	{
		// try to slice the right number of review_ids of the pending list
		var list = loop_base.pending.slice(0, count);
		var list_length = list.length;

		//console.log('strlen', list, list_length);return;

		// make a list of pending review_ids that needs to be loaded
		var missing = [];

		// loop the sliced list of review_ids
		for(var row_nr = 0; row_nr < list_length; row_nr++)
		{
			var review_id = list[row_nr];

			// if review isn't pre-loaded
			if(!testseek.aur_content[review_id])
			{
				// add it to the list of missing
				missing.push(review_id);
			}
		}

		// at least one is missing, use ajax
		if(missing.length > 0)
		{
			// create an ajax object
			var ajax = new XMLHttpRequest();

			// add a listner to catch when request done
			ajax.onreadystatechange = function() {
				// ignore all states except DONE
				if(ajax.readyState == /* XMLHttpRequest.DONE */ 4)
				{
					// if ok response (http code 200)
					if(ajax.status == 200)
					{
						// answer has a parsed JSON
						if(ajax.responseJSON)
						{
							// call the response-handler with the parsed JSON
							window.testseek.handle_respone(ajax.responseJSON, []);
						}
						else
						{
							// call the response-handler with the JSON-string
							window.testseek.handle_respone(ajax.responseText, []);
						}

						// Extend the element with the new reviews
						window.testseek.extend_aur(loop_base, list);
					}
					// other response
					else if(window.testseek.verbose)
					{
						// Log
						console.log(ajax.status);
						console.log(ajax);
					}
				}
			};

			// Send ajax
			ajax.open("POST", window.testseek.search_url, true);
			ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
			ajax.send("aur_ids=" + missing.join(','));
		}
		// all reviews are already loaded
		else
		{
			// Extend the element with the new reviews
			window.testseek.extend_aur(loop_base, list);
		}
	}
}
/* End of load_more_aur.js */

/* Start of load_more_er.js */
/**
 * Load and extend a ereview-loop with more content
 *
 * @param loop_base HTMLElement the element to extend, using its .ts.template
 * @param count int number of reviews to extend it with
 *
 * @depends search_url, handle_respone, extend_er
 **/

window.testseek.load_more_er = function(loop_base, count)
{
	console.log('davajce', loop_base, count, loop_base.pending.length); //return;
	// if there is more reviews pending to be loaded
	if(loop_base.pending.length > 0)
	{
		// try to slice the right number of review_ids of the pending list
		var list = loop_base.pending.slice(0, count);
		var list_length = list.length;

		// make a list of pending review_ids that needs to be loaded
		var missing = [];

		// loop the sliced list of review_ids
		for(var row_nr = 0; row_nr < list_length; row_nr++)
		{
			var review_id = list[row_nr];

			//console.log('kako ovo ima?? ER', testseek.ereviews);
			// if review isn't loaded
			if(!testseek.ereviews[review_id])
			{
				// add it to the list of missing
				missing.push(review_id);
			}
		}

		// at least one is missing, use ajax
		if(missing.length > 0)
		{
			// create an ajax object
			var ajax = new XMLHttpRequest();

			// add a listner to catch when request done
			ajax.onreadystatechange = function() {
				// ignore all states except DONE
				if(ajax.readyState == /* XMLHttpRequest.DONE */ 4)
				{
					// if ok response (http code 200)
					if(ajax.status == 200)
					{
						// answer has a parsed JSON
						if(ajax.responseJSON)
						{
							// call the response-handler with the parsed JSON
							window.testseek.handle_respone(ajax.responseJSON, []);
						}
						else
						{
							// call the response-handler with the JSON-string
							window.testseek.handle_respone(ajax.responseText, []);
						}

						// Extend the element with the new reviews
						window.testseek.extend_er(loop_base, list);
					}
					// other response
					else if(window.testseek.verbose)
					{
						// Log
						console.log(ajax.status);
						console.log(ajax);
					}
				}
			};

			// Send ajax
			ajax.open("POST", window.testseek.search_url, true);
			ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
			ajax.send("er_ids=" + missing.join(','));
		}
		// all reviews are already loaded
		else
		{
			// Extend the element with the new reviews
			window.testseek.extend_er(loop_base, list);
		}
	}
}
/* End of load_more_er.js */

/* Start of load_template_by_url.js */
window.testseek.load_template_by_url = function(template_name, url) {
	var ajax = new XMLHttpRequest();
	ajax.onreadystatechange = function() {
		if(ajax.readyState == /* XMLHttpRequest.DONE */ 4)
		{
			if(ajax.status == 200)
			{
				window.testseek.templates[template_name] = ajax.responseText;
				if(window.testseek.verbose)
				{
					console.log(['template loaded', template_name]);
				}
				window.testseek.load_held();
			}
			else if(window.testseek.verbose);
			{
				console.log(ajax.status);
				console.log(ajax);
			}
		}
	};

	ajax.open("GET", url, true);
	ajax.send();
}
/* End of load_template_by_url.js */

/* Start of parseQuery.js */
window.testseek.parseQuery = function(url_query)
{
	var result = {};
	var pair;
	var key;
	var value;
	var vars = url_query.split('&');
	var var_count = vars.length;

	for(var i = 0; i < var_count; i++)
	{
		pair = vars[i].split('=');
		key = decodeURIComponent(pair[0]);
		if(pair.length == 1)
		{
			value = "";
		}
		else
		{
			value = decodeURIComponent(pair.slice(1).join("="));
		}

		if(key.substr(key, key.length - 2) == "[]")
		{
			key = key.substr(key, 0, key.length - 2);
			if(!result[key] || !result[key].push)
			{
				result[key] = [];
			}
			result[key].psuh(value);
		}
		else
		{
			result[key] = value;
		}
	}

	return result;
}
/* End of parseQuery.js */

/* Start of play_video.js */
window.testseek.play_video = function(id, element) {
	var video = window.testseek.videos[id];
	if(video)
	{
		element.setAttribute('data-ts-video-id', id);
		element.setAttribute('src', video.video_url.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/") + '?autoplay=1');
		return true;
	}
	return false;
}
/* End of play_video.js */

/* Start of popup.js */
window.testseek.close_popup = function(ts_id, template) {
	var ts_popup = document.getElementById('ts_popup');
	var ts_popup_child = document.getElementById('ts_popup_child');
	if(!ts_popup)
	{
		return true;
	}
	ts_popup.style.display = 'none';
	ts_popup_child.innerHTML = '';

	return true;
}

window.testseek.popup = function(ts_id, template) {
	var ts_popup = document.getElementById('ts_popup');
	var ts_popup_child = document.getElementById('ts_popup_child');
	var new_ts_popup = !ts_popup;
	if(new_ts_popup)
	{
		ts_popup = document.createElement("DIV");
		ts_popup.id = 'ts_popup';
		ts_popup.className = 'ts_popup';
		ts_popup.ts = {"className": '' + ts_popup.className};

		var ts_popup_bg = document.createElement("DIV");
		ts_popup_bg.id = 'ts_popup_bg';
		ts_popup_bg.className = 'ts_popup_bg';
		ts_popup_bg.ts = {"className": '' + ts_popup.className};
		ts_popup.appendChild(ts_popup_bg);
		ts_popup_bg.onclick = window.testseek.close_popup;

		ts_popup_child = document.createElement("DIV");
		ts_popup_child.id = 'ts_popup_child';
		ts_popup_child.className = 'ts_popup_child';
		ts_popup_child.ts = {"className": '' + ts_popup.className};
		ts_popup.appendChild(ts_popup_child);
	}
	else
	{
		ts_popup.className = ts_popup.ts.className;
		ts_popup.style.display = 'block';

		ts_popup_child.className = ts_popup_child.ts.className;
		ts_popup_child.style.display = 'block';
	}

//loading our owl animation in case there's a queuee
		ts_popup_child.innerHTML = '<img style="display:block;margin-left:auto;margin-right:auto;" title="Loading..." src="https://' + window.testseek.ts_domain + '/templates/v2/images/flying_owl.gif' + '"><h3 style="text-align:center;">Loading...</h3>';

	ts_popup_child.setAttribute('data-ts-id', ts_id);
	ts_popup_child.ts.ts_id = ts_id;
	if(template)
	{
		ts_popup_child.ts.template_name = template;
	}
	else if(window.testseek.popup_template)
	{
		ts_popup_child.ts.template_name = window.testseek.popup_template;
	}
	else
	{
		if(window.testseek.verbose)
		{
			console.log("No popup template selected");
		}
		return false;
	}

	window.testseek.pending.push(ts_popup_child);
	if(new_ts_popup)
	{
		document.body.appendChild(ts_popup);
	}
	ts_popup_child.scrollIntoView();
	return window.testseek.load_held();
}
/* End of popup.js */

/* Start of render_au_review.js */
/*
Rendering of full AUR - NFR June 2021.
*/
window.testseek.render_au_review = function(template, review)
{
	//console.log('aurevObj', review);

	//decompile object
	aurss_product_reviews_aureview_id = review.aureview_id;
	aurss_product_reviews_author = review.author_name;
	aurss_product_reviews_date = review.publish_date;
	aurss_product_reviews_stars = review.stars;
	aurss_product_reviews_headline = review.headline;
	aurss_product_reviews_text = review.text_comment;
	aurss_product_reviews_good = review.text_good;
	aurss_product_reviews_bad = review.text_bad;
	aurss_product_reviews_bottomline = review.text_bottomline;
	aurss_product_reviews_aurss_name = review.aurss_name;
	//TODO perhaps link original AURSS product URL as well?


	//FIXME only testing
	/*aurss_product_reviews_good = aurss_product_reviews_good ? aurss_product_reviews_good : 'Good!';
	aurss_product_reviews_bad = aurss_product_reviews_bad ? aurss_product_reviews_bad : 'Bad!';
	aurss_product_reviews_bottomline = aurss_product_reviews_bottomline ? aurss_product_reviews_bottomline : 'Bottom!';
	aurss_product_reviews_headline = aurss_product_reviews_headline ? aurss_product_reviews_headline : 'Head!';*/


	//var test_site = window.testseek.test_sites[review.test_site_id];
	var l = aurss_product_reviews_aureview_id;
	var flag_position = [-20 * (l % 10), 'px ', -13 * (l - (l % 10)) / 10, 'px'].join('');
	var classes = ['ts_e_review', 'ts_no_award', 'ts_comment_have_parts', 'ts_comment_have_sc_full_aur'];

	//if(aurss_product_reviews_bad || aurss_product_reviews_good || aurss_product_reviews_bottomline || aurss_product_reviews_headline)
	if(aurss_product_reviews_bad || aurss_product_reviews_good || aurss_product_reviews_bottomline)
	{
		//classes.push('ts_comment_have_parts');
	//	classes.push('ts_have_comment');
	}

	if(aurss_product_reviews_text)
	{
		//classes.push('ts_comment_no_parts');
		classes.push('ts_have_comment');
	}
	else
	{
		classes.push('ts_no_comment');
		//classes.push('ts_comment_no_parts');
	}

	//aurss_product_reviews_bad = 'numerose ore di costruzione...';
	if(aurss_product_reviews_bad)
	{
		classes.push('ts_comment_have_bad');
	}
	else
	{
		classes.push('ts_comment_no_bad');
	}

	//aurss_product_reviews_good = 'znznznz';
	if(aurss_product_reviews_good)
	{
		classes.push('ts_comment_have_good');
	}
	else
	{
		classes.push('ts_comment_no_good');
	}

	if(aurss_product_reviews_bottomline)
	{
		classes.push('ts_comment_have_bottom');
	}
	else
	{
		classes.push('ts_comment_no_bottom');
	}

	if(aurss_product_reviews_headline)
	{
		classes.push('ts_comment_have_headline');
	}
	else
	{
		classes.push('ts_comment_no_headline');
	}

	if(aurss_product_reviews_stars)
	{
		classes.push('ts_have_score');
		//classes.push('ts_no_score');

	/*	loveWillTearUsApart = Math.round(aurss_product_reviews_stars / 5) * 100;
		var kita = 4/5 * 100;

		console.log('kita?', kita, 'legooo skor', aurss_product_reviews_aureview_id, aurss_product_reviews_stars, loveWillTearUsApart);

		stabre = 'score_' + loveWillTearUsApart;

		console.log('eeek??', stabre);*/


		//classes.push('score_' + Math.round(aurss_product_reviews_stars / 10) * 10);
		//classes.push('score_' + aurss_product_reviews_stars);
		//TODO use MAX score here where 5
		//console.log(aurss_product_reviews_stars, aurss_product_reviews_stars / 5 * 100);

		classes.push('score_' + aurss_product_reviews_stars / 5 * 100);
		//classes.push('score_' + Math.round(100 * aurss_product_reviews_stars) / 10);
		//console.log('zvezdice', aurss_product_reviews_stars, Math.round(aurss_product_reviews_stars / 10) * 10);
	}
	else
	{
		classes.push('ts_no_score');
	}

	//loveWillTearUsApart = stabre = null;

	if(aurss_product_reviews_author)
	{
		classes.push('ts_have_author');
	}
	else
	{
		classes.push('ts_no_author');
	}

	if(aurss_product_reviews_date)
	{
		classes.push('ts_have_date');
	}
	else
	{
		classes.push('ts_no_date');
	}

	//var starsTMPL = '<span class="ts_aur_review_stars_rating"><i>★</i><i>★</i><i>★</i><u class="ts-empty-star">★</u><u class="ts-empty-star">★</u></span>';
	//test aurss_product_reviews_stars
	//aurss_product_reviews_stars = 2;
	//console.log('stars kolko?', aurss_product_reviews_stars);
	//TODO tmp hardcocde max, take it from AUreview itself!
	var maxStarsAUR = 5;
	var emptyStarsCnt = maxStarsAUR - aurss_product_reviews_stars;
	var starsBuffer = '';
	var emptyStarsBuffer = '';

	//first populate full stars
	for (var star = 1; star <= aurss_product_reviews_stars; star++)
	{
		starsBuffer = starsBuffer + '<i>★</i>';
	}

	//then empty stars
	for (var emptyStar = 1; emptyStar <= emptyStarsCnt; emptyStar++)
	{
		emptyStarsBuffer = emptyStarsBuffer + '<u class="ts-empty-star">★</u>'
	}
	//TODO think about half stars for the future?

	var finalStarsBuffer = starsBuffer + emptyStarsBuffer;
	var starsTMPL = '<span title="' + aurss_product_reviews_stars + ' / ' + maxStarsAUR + '" class="ts_aur_review_stars_rating">%starsInside%</span>';
	starsTMPL = starsTMPL.replace('%starsInside%', finalStarsBuffer);
	//console.log('eee??', starsBuffer, emptyStarsBuffer, finalStarsBuffer, starsTMPL);

	//x.style.display = "block";
	//Hide inactive product URLs, see GitLab #332
	//!review.url && classes.push('ts_aer_product_url_inactive');
	// shortcode for htmlentities()
	var he = window.testseek.htmlentities;
	return template
				.replace(/%ts_aur_review_stars_rating%/g, starsTMPL)
				.replace(/%aureview_id%/g, 1 * aurss_product_reviews_aureview_id)
				.replace(/%aur_full_class%/g, he(classes.join(' ')))
				.replace(/%er_author%/g,  	he(aurss_product_reviews_author))
				//.replace(/%ts_show_if_sc_full_aur%/g, '')
				.replace(/%er_author_date%/g, he(aurss_product_reviews_date))
				.replace(/%er_site%/g, he(aurss_product_reviews_aurss_name))
				.replace(/%aur_stars_score%/g, Math.round(aurss_product_reviews_stars))
				.replace(/%aur_stars_class%/g, 'stammered') //xD
				.replace(/%aurss_product_reviews_good%/g, he(aurss_product_reviews_good))
				.replace(/%aurss_product_reviews_bad%/g, he(aurss_product_reviews_bad))
				.replace(/%aurss_product_reviews_bottomline%/g, he(aurss_product_reviews_bottomline))
				.replace(/%aurss_product_reviews_headline%/g, he(aurss_product_reviews_headline))
				.replace(/%aurss_product_reviews_text%/g, he(aurss_product_reviews_text));
};/* End of render_au_review.js */

/* Start of render_e_review.js */
window.testseek.render_e_review = function(template, review)
{
	var test_site = window.testseek.test_sites[review.test_site_id];
	var l = review.language_id;
	var flag_position = [-20 * (l % 10), 'px ', -13 * (l - (l % 10)) / 10, 'px'].join('');
	var classes = ['ts_e_review'];
	if(review.test_comment_bad || review.test_comment_good || review.test_comment_bottomline)
	{
		classes.push('ts_comment_have_parts');
		classes.push('ts_have_comment');
	}
	else if(review.test_comment)
	{
		classes.push('ts_comment_no_parts');
		classes.push('ts_have_comment');
	}
	else
	{
		classes.push('ts_no_comment');
		classes.push('ts_comment_no_parts');
	}
	if(review.test_comment_bad)
	{
		classes.push('ts_comment_have_bad');
	}
	else
	{
		classes.push('ts_comment_no_bad');
	}
	if(review.test_comment_good)
	{
		classes.push('ts_comment_have_good');
	}
	else
	{
		classes.push('ts_comment_no_good');
	}
	if(review.test_comment_bottomline)
	{
		classes.push('ts_comment_have_bottom');
	}
	else
	{
		classes.push('ts_comment_no_bottom');
	}

	if(review.score)
	{
		classes.push('ts_have_score');
		classes.push('score_' + Math.round(review.score / 10) * 10);
	}
	else
	{
		classes.push('ts_no_score');
	}

	if(review.award_image)
	{
		classes.push('ts_have_award');
	}
	else
	{
		classes.push('ts_no_award');
	}

	if(review.test_author)
	{
		classes.push('ts_have_author');
	}
	else
	{
		classes.push('ts_no_author');
	}

	if(review.publish_date)
	{
		classes.push('ts_have_date');
	}
	else
	{
		classes.push('ts_no_date');
	}

	//Hide inactive product URLs, see GitLab #332
	!review.url && classes.push('ts_aer_product_url_inactive');

	// shortcode for htmlentities()
	var he = window.testseek.htmlentities;

	return template
				.replace(/%review_id%/g, 1 * review.review_id)
				.replace(/%er_class%/g, he(classes.join(' ')))
				.replace(/%er_author%/g,  	he(review.test_author))
				.replace(/%er_author_date%/g, he(review.publish_date))
				.replace(/%er_award_image%/g, he(review.award_image_url))
				.replace(/%er_award_image_200%/g, review.award_image_200_url)
				.replace(/%award_name%/g, he(review.award_name))
				.replace(/%er_award_name%/g, he(review.award_image_name))
				.replace(/%er_bottom%/g, he(review.test_comment_bottomline))
				.replace(/%er_comment%/g, he(review.test_comment))
				.replace(/%er_con%/g, he(review.test_comment_bad))
				.replace(/%er_flag_position%/g, flag_position)
				.replace(/%er_locale%/g, he(review.locale_id))
				.replace(/%er_pro%/g, he(review.test_comment_good))
				.replace(/%er_score_float%/g, 1 * review.score)
				.replace(/%er_score%/g, Math.round(review.score))
				.replace(/%er_org_score%/g, Math.round(review.org_score))
				.replace(/%er_max_score%/g, Math.round(review.max_score))
				.replace(/%er_site_id%/g, 1 * review.test_site_id)
				.replace(/%er_site%/g, he(test_site.name))
				.replace(/%er_site_logo%/g, he(test_site.logo_url))
				.replace(/%er_url%/g, he(review.url))
				.replace(/%er_up_votes%/g, 1 * review.up_votes)
				.replace(/%er_down_votes%/g, 1 * review.down_votes)
};


/* End of render_e_review.js */

/* Start of render_element.js */
window.testseek.render_element = function(element)
{
	if(!element.ts)
	{
		if(window.testseek.verbose)
		{
			console.log(['No parameters', element]);
		}
		return false;
	}

	if(!element.ts.ts_id)
	{
		if(window.testseek.verbose)
		{
			console.log(['No Product', element]);
		}
		return false;
	}

	if(!this.products[element.ts.ts_id])
	{
		if(window.testseek.verbose)
		{
			console.log(['Product not loaded', element.ts.ts_id, element]);
		}
		return false;
	}

	if(!element.ts.template_name)
	{
		if(window.testseek.verbose)
		{
			console.log(['No template', element]);
		}
		return false;
	}

	if(!this.templates[element.ts.template_name])
	{
		if(window.testseek.verbose)
		{
			console.log(['Template not loaded', element.ts.template_name, element]);
		}
		return false;
	}

	if(element.tagName == 'A' || (element.tagName == 'SCRIPT' && element.parentNode.tagName != 'HEAD'))
	{
		var new_element = document.createElement('DIV');
		new_element.ts = element.ts;
		new_element.className = element.className;
		new_element.style = element.style;
		element.parentNode.replaceChild(new_element, element);
		element = new_element;
	}
	this.update_class(element, this.products[element.ts.ts_id]);
	this.render_template(element.ts.template_name, this.products[element.ts.ts_id], element);

	window.testseek.render_finish_activate();

	return true;
}
/* End of render_element.js */

/* Start of render_finish.js */
window.testseek.render_finish_activate = function()
{
	if(window.testseek.verbose)
	{
		console.log('render_finish_activate()');
	}
	if(window.testseek.after_render_timer)
	{
		clearTimeout(window.testseek.after_render_timer);
	}
	window.testseek.after_render_timer = setTimeout(
		function() {
			window.testseek.render_finish();
			window.testseek.after_render_timer = null;
		},
		300
	);
}

window.testseek.render_finish = function()
{
	if(window.testseek.verbose)
	{
		console.log('render_finish()');
	}
	window.testseek.inline_iframe_init();
	testseek.svg_graph_load();
	window.testseek.bar_animate();
	window.testseek.feature_animate();
	//console.log('Disabled - neither ER nor AUR tabs takes precedence');
	//window.testseek.tab_select_init(); //disabled in v5.5.0

	setTimeout(window.testseek.resize_iframes, 800);
}
/* End of render_finish.js */

/* Start of render_template.js */
window.testseek.render_template = function(template_name, product_data, element)
{
	if(!this.templates[template_name])
	{
		console.log("Template missing: " + template_name);
		return template_name;
	}

	// shortname for htmlentities()
	var he = window.testseek.htmlentities;

	var a_score_count = (product_data.astars_1 || 0) + (product_data.astars_2 || 0) + (product_data.astars_3 || 0) + (product_data.astars_4 || 0) + (product_data.astars_5);

	var our_awards = ["","award_ed_choice_200x186.png","award_most_awarded_200x186.png","award_best_rank_200x186.png","award_good_buy_200x186.png","award_recommended_200x186.png"];

	var first_video_url = '';
	var type_options = [];
	var language_options = [];
	var quality_options = [];
	if(product_data.videos && product_data.videos[0])
	{
		var first_video = window.testseek.videos[product_data.videos[0]];

		if(first_video)
		{
			first_video_url = first_video.video_url.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/");
		}
		else
		{
			first_video = {video_id: 0, up_votes: 0, down_votes: 0};
		}

		var video_count = product_data.videos.length;
		var video_types = {};
		var video_languages = {};
		var video_qualities = {};
		for(video_nr = 0; video_nr < video_count; video_nr++)
		{
			var current_video = window.testseek.videos[product_data.videos[video_nr]];

			if(current_video)
			{
				if(video_types[current_video.video_type_name])
				{
					video_types[current_video.video_type_name]++;
				}
				else
				{
					video_types[current_video.video_type_name] = 1;
				}

				var video_locale = current_video.locale_id.split('-')[0];
				if(video_languages[video_locale])
				{
					video_languages[video_locale].count++;
				}
				else
				{
					var video_lang = current_video.locale_descr.split(' - ')[0];
					video_languages[video_locale] = {count: 1, name: video_lang};
				}

				if(video_qualities[current_video.video_quality])
				{
					video_qualities[current_video.video_quality]++;
				}
				else
				{
					video_qualities[current_video.video_quality] = 1;
				}
			}
		}

		var l10n = window.testseek.l10n;
		if(video_count)
		{
			video_types = window.testseek.asort_num(video_types, true);
			video_languages = window.testseek.asort_func(
				video_languages,
				function(a, b) {
					// b - a => DESC
					return b[1].count - a[1].count;
				}
			);
			video_qualities = window.testseek.asort_num(video_qualities, true);

			for(var video_type in video_types)
			{
				type_options.push('<option value="' + he(video_type) + '">' + he(l10n('video_type_' + video_type)) + ' (' + he(video_types[video_type]) + ')</option>');
			}
			for(var video_locale in video_languages)
			{
				language_options.push('<option value="' + he(video_locale) + '">' + he(video_languages[video_locale].name) + ' (' + he(video_languages[video_locale].count) + ')</option>');
			}
			for(var video_quality in video_qualities)
			{
				if(video_quality)
				{
					quality_options.push('<option value="' + he(video_quality) + '">' + he(video_quality) + ' (' + he(video_qualities[video_quality]) + ')</option>');
				}
			}
		}
	}
	else
	{
		first_video = {video_id: 0, up_votes: 0, down_votes: 0};
	}


	//var stars_tmpl_visibility_class = 'ts_hide_stars_tmpl';//abandon
	//var a_score_class = 'score_' + Math.round(product_data.aur_avg_score_subset / 10) * 10;
/*	product_data.aur_avg_score = 49;
	console.log(product_data.aur_avg_score);*/
	var a_score_class = 'score_' + Math.round(product_data.aur_avg_score / 10) * 10; //display score class from real subset (filtered AURSS)
	var e_score_class = 'score_' + Math.round(product_data.aer_avg_score_subset / 10) * 10;

	//a_score_class = ath.round(product_data.aer_avg_score_subset / 10) * 10;;
	//console.log('jooj', a_score_class, Math.round(product_data.aur_avg_score));


	// auto stars

    var aurScoreTooLow = window.testseek.filters.product_min_aur_score > product_data.aur_avg_score; //this is real subset to compare against

    //var aur_avaible = product_data.config.show.aurss && testseek.request_config.aureviews && product_data.aur_count_subset > 0;
	var aur_avaible = product_data.config.show.aurss && testseek.request_config.aureviews && product_data.aur_score_count_subset > 0 && !aurScoreTooLow; //aur_score_count_subset is the real subset
	//var er_avaible = product_data.config.show.ers && testseek.request_config.ereviews && product_data.aer_count_all > 0;
	var er_avaible = product_data.config.show.ers && testseek.request_config.ereviews && product_data.aer_count_subset > 0;
	if(aur_avaible)
	{
		if(er_avaible)
		{
			// combine scores AER + AUR

            var aerAvgScoreSubset = product_data.aer_avg_score_subset;
            var aurAvgScore = product_data.aur_avg_score;

            //If AER scores are N/A (0x00), do not use them for avg score calculation, use only AUR scores which by default must always have score ratings
			var avg_score = aerAvgScoreSubset ? (aerAvgScoreSubset + aurAvgScore)/2 : aurAvgScore;
			//var avg_score = (product_data.aur_avg_score + product_data.aer_avg_score_subset)/2;  //use score from real subset (filtered AURSS)

			var avg_class = 'score_' + Math.round(avg_score / 10) * 10;
			//auto_stars = {type: 'aur+er', count: product_data.aur_count_subset + product_data.aer_count_all, score: Math.round(100 * avg_score)/100, class: avg_class};
			auto_stars = {type: 'aur+er', count: product_data.aur_count_subset + product_data.aer_count_subset, score: Math.round(100 * avg_score)/100, class: avg_class};
		}
		else
		{
			//auto_stars = {type: 'aur', count: product_data.aur_count_subset, score: Math.round(100 * product_data.aur_avg_score_subset)/100, class: a_score_class};
			auto_stars = {type: 'aur', count: product_data.aur_count_subset, score: Math.round(100 * product_data.aur_avg_score)/100, class: a_score_class};  //display score class from real subset (filtered AURSS)
		}
	}
	// only E-reviews avaible?
	// + fallback expert reviews --> Nemanja Q: what is the purpose of fallback to AER ratings when we needed AUR?!
	else
	{
		//auto_stars = {type: 'expert', count: product_data.aer_count_all, score: Math.round(100 * product_data.aer_avg_score_subset)/100, class: e_score_class};
		auto_stars = {type: 'expert', count: product_data.aer_count_subset, score: Math.round(100 * product_data.aer_avg_score_subset)/100, class: e_score_class};
	}

	/*console.log('autopark pre', auto_stars);
	auto_stars.score = 60.55;
	auto_stars.count = 11;
	auto_stars.class = 'score_70';
	console.log('autopark posle', auto_stars);*/

	//console.log('autopark posle', auto_stars);

	element.innerHTML = this.templates[template_name]
		// Base values
		.replace(/%product_name%/g, he(product_data.product_name))
		.replace(/%product_url%/g, he(product_data.url))
		.replace(/%ts_id%/g, he(product_data.our_article_id.toLowerCase()))
		.replace(/%ts_award_id%/g, 1 * product_data.our_award_id)
		.replace(/%ts_award_url%/g, he(product_data.our_award_id ? 'https://' + testseek.ts_domain + '/images/' + our_awards[product_data.our_award_id] : ''))

		// Icons
		.replace(/%icon_star%/g, this.icons('star'))
		.replace(/%icon_half_star%/g, this.icons('half_star'))
		.replace(/%icon_empty_star%/g, this.icons('empty_star'))
		.replace(/%icon_tup%/g, this.icons('tup'))
		.replace(/%icon_tdown%/g, this.icons('tdown'))

		// TS-score, auto between aur and expert score
		.replace(/%ts_score%/g, 1 * auto_stars.score)
		.replace(/%ts_score_class%/g, auto_stars.class)
		.replace(/%ts_score_count%/g, 1 * auto_stars.count)
        //.replace(/%stars_tmpl_visibility_class%/g, stars_tmpl_visibility_class) //abandon

		// E-summary
		//.replace(/%e_count%/g, 1 * product_data.aer_count_all)
		.replace(/%e_count%/g, 1 * product_data.aer_count_subset) //show subset, instead of global raw value from DB
		.replace(/%e_score%/g, Math.round(product_data.aer_avg_score_subset))
		.replace(/%e_score_class%/g, e_score_class)
		.replace(/%e_full_score%/g, 1 * product_data.aer_avg_score_all)
		.replace(/%e_score_count%/g, 1 * product_data.aer_score_count_subset)
		.replace(/%escore_5star_score%/g, product_data.aer_score_count_subset ? 100 * product_data.estars_5 / product_data.aer_score_count_subset : 0)
		.replace(/%escore_4star_score%/g, product_data.aer_score_count_subset ? 100 * product_data.estars_4 / product_data.aer_score_count_subset : 0)
		.replace(/%escore_3star_score%/g, product_data.aer_score_count_subset ? 100 * product_data.estars_3 / product_data.aer_score_count_subset : 0)
		.replace(/%escore_2star_score%/g, product_data.aer_score_count_subset ? 100 * product_data.estars_2 / product_data.aer_score_count_subset : 0)
		.replace(/%escore_1star_score%/g, product_data.aer_score_count_subset ? 100 * product_data.estars_1 / product_data.aer_score_count_subset : 0)
		.replace(/%escore_5star_count%/g, 1 * product_data.estars_5)
		.replace(/%escore_4star_count%/g, 1 * product_data.estars_4)
		.replace(/%escore_3star_count%/g, 1 * product_data.estars_3)
		.replace(/%escore_2star_count%/g, 1 * product_data.estars_2)
		.replace(/%escore_1star_count%/g, 1 * product_data.estars_1)
		.replace(/%escore_noscore_count%/g, 1 * product_data.estars_0)

		// A-review summary
		.replace(/%a_count%/g, 1 * product_data.aur_count_subset)
		//.replace(/%a_score%/g, Math.round(product_data.aur_avg_score_subset))
		.replace(/%a_score%/g, product_data.aur_avg_score ? Math.round(product_data.aur_avg_score) : 0x00) //display score from real subset (filtered AURSS)
		.replace(/%a_score_class%/g, a_score_class)
		.replace(/%ascore_5star_score%/g, a_score_count ? 100 * product_data.astars_5 / a_score_count : 0)
		.replace(/%ascore_4star_score%/g, a_score_count ? 100 * product_data.astars_4 / a_score_count : 0)
		.replace(/%ascore_3star_score%/g, a_score_count ? 100 * product_data.astars_3 / a_score_count : 0)
		.replace(/%ascore_2star_score%/g, a_score_count ? 100 * product_data.astars_2 / a_score_count : 0)
		.replace(/%ascore_1star_score%/g, a_score_count ? 100 * product_data.astars_1 / a_score_count : 0)
		.replace(/%ascore_5star_count%/g, 1 * product_data.astars_5 || 0)
		.replace(/%ascore_4star_count%/g, 1 * product_data.astars_4 || 0)
		.replace(/%ascore_3star_count%/g, 1 * product_data.astars_3 || 0)
		.replace(/%ascore_2star_count%/g, 1 * product_data.astars_2 || 0)
		.replace(/%ascore_1star_count%/g, 1 * product_data.astars_1 || 0)

		// Video summary/preview
		.replace(/%v_count%/g, 1 * product_data.videos_count_all)
		.replace(/%first_video_url%/g, he(first_video_url))
		.replace(/%first_video_id%/g, 1 * first_video.video_id)
		.replace(/%first_video_up_votes%/g, 1 * first_video.up_votes)
		.replace(/%first_video_down_votes%/g, 1 * first_video.down_votes)
		.replace(/%video_type_options%/g, type_options.join("\n"))
		.replace(/%video_language_options%/g, language_options.join("\n"))
		.replace(/%video_quality_options%/g, quality_options.join("\n"));

	if ('rich_snippet' === template_name) {
		//console.log(template_name, element.id, element.tsHideRS, element.innerHTML, element);

		//hide entire rich snippet node when no AER and no AUR ratings are available, flag is set elsewhere - in update_class() method)
		if (element.tsHideRS && element.hasChildNodes()) element.removeChild(element.childNodes[0]);

		//if (element.tsHideRS) element.innerHTML = '';

		/*if (element.tsHideRS){
			while (element.firstChild) {
				element.removeChild(element.lastChild);
			}
		}*/

		//console.log('posle?', element.tsHideRS, element);
	}

	// E-summary Pro loop
	var loop_elements = element.getElementsByClassName('ts_e_summary_pros_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%pro_nop%/g, '');
			}

			var items_html = [];

			if(product_data.e_pros)
			{
				var pro_count = product_data.e_pros.length;
				for(var pro_nr = 0; pro_nr < pro_count; pro_nr++)
				{
					items_html.push(
						loop_base.ts_template
							.replace(/%pro_name%/g, he(product_data.e_pros[pro_nr]))
					);
				}
			}

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}

	// E-summary Con loop
	var loop_elements = element.getElementsByClassName('ts_e_summary_cons_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%con_nop%/g, '');
			}

			var items_html = [];

			if(product_data.e_cons)
			{
				var con_count = product_data.e_cons.length;
				for(var con_nr = 0; con_nr < con_count; con_nr++)
				{
					items_html.push(
						loop_base.ts_template
							.replace(/%con_name%/g, he(product_data.e_cons[con_nr]))
					);
				}
			}

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}

	// E-summary award loop
	var loop_elements = element.getElementsByClassName('ts_award_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%award_nop%/g, '');
			}

			var items_html = [];

			if(product_data.awards)
			{
				var award_count = product_data.awards.length;
				for(var award_nr = 0; award_nr < award_count; award_nr++)
				{
					var product_award = product_data.awards[award_nr];
					items_html.push(
						loop_base.ts_template
							.replace(/%award_name%/g, he(product_award.name))
							.replace(/%award_url%/g, he(product_award.image_url))
					);
				}
			}

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}

	// A-review summary Features loop
	var loop_elements = element.getElementsByClassName('ts_aur_summary_feature_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%aur_sf_nop%/g, '');
			}

			var items_html = [];

			if(product_data.aur_features)
			{
				for(var feature_name in product_data.aur_features)
				{
					var features = product_data.aur_features[feature_name];
					items_html.push(
						loop_base.ts_template
							.replace(/%aur_sf_name%/g, he(feature_name))
							.replace(/%aur_sf_score%/g, Math.round(features.sum / features.count))
							.replace(/%aur_sf_score_count%/g, 1 * features.count)
							.replace(/%aur_sf_score_sum%/g, 1 * features.sum)
					);
				}
			}

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}

	// A-review summary Pro loop
	var loop_elements = element.getElementsByClassName('ts_aur_summary_pros_loop');
	if(loop_elements)
	{
        //var prosConsBoxID = document.getElementById('ts_aur_pros_cons_box');

		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%aur_summary_pro_nop%/g, '');
			}

			var items_html = [];

			if(product_data.a_pros.length)
			{
				var pro_count = product_data.a_pros.length;
				for(var pro_nr = 0; pro_nr < pro_count; pro_nr++)
				{
					items_html.push(
						loop_base.ts_template.replace(
							/%aur_summary_pro_name%/g,
							he(product_data.a_pros[pro_nr].t) +
								(
									product_data.a_pros[pro_nr].c > 1 ?
									' (' + product_data.a_pros[pro_nr].c + ')' :
									''
								)
						)
					);
				}
			}
			/*else {
                console.log('no a_pros found in ts_aur_summary_pros_loop!');
			}*/

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}

	// A-review summary Con loop
	var loop_elements = element.getElementsByClassName('ts_aur_summary_cons_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%aur_summary_con_nop%/g, '');
			}

			var items_html = [];

			if(product_data.a_cons)
			{
				var con_count = product_data.a_cons.length;
				for(var con_nr = 0; con_nr < con_count; con_nr++)
				{
					items_html.push(
						loop_base.ts_template.replace(
							/%aur_summary_con_name%/g,
							he(product_data.a_cons[con_nr].t) +
								(
									product_data.a_cons[con_nr].c > 1 ?
									' (' + product_data.a_cons[con_nr].c + ')' :
									''
								)
						)
					);
				}
			}

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}

	// Aurss loop
	var loop_elements = element.getElementsByClassName('ts_aurss_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%aurss_nop%/g, '');
			}

			var items_html = [];

			if(product_data.aurss)
			{
				for(var aurss_id in product_data.aurss)
				{
					var aurss = this.aurss[aurss_id];
					var product_aurss = product_data.aurss[aurss_id];
					if(!product_aurss.score_count)
					{
						continue;
					}
					var l = aurss.language_id;
					var flag_position = [-20 * (l % 10), 'px ', -13 * (l - (l % 10)) / 10, 'px'].join('');
					var aurss_classes = [];
					aurss_classes.push('ts_aurss');
					aurss_classes.push(product_aurss.features ? 'ts_aurss_have_features' : 'ts_aurss_no_features');
					aurss_classes.push(product_aurss.recommend_yes ? 'ts_aurss_have_recommend' : 'ts_aurss_no_recommend');
					//aurss_classes.push('score_' + Math.round(product_aurss.score_sum / product_aurss.score_count / 10) * 10);
                    aurss_classes.push('score_' + Math.round(product_aurss.aurss_score / 10 ) * 10);

                    //Get assoc array of product URLs from API response, see GitLab #312
                    //const product_page_urls = product_aurss.product_page_urls ? product_aurss.product_page_urls : null;
                    var product_page_urls = product_aurss.product_page_urls ? product_aurss.product_page_urls : null;

                    //Get assoc array of AUR content data from API response
                    //var product_aurss_full_content = product_aurss.reviews ? product_aurss.reviews : null;
                    //var product_aurss_full_content = product_data.aur_content ? product_data.aur_content : null;
					//console.log('kude si', product_data); // product_data, testseek.aur_content);
                    var product_aurss_full_content = product_data.aur_content ? product_data.aur_content : null;
                    var product_aurss_reviews_list = product_aurss.aureviews ? product_aurss.aureviews : null;
                    //console.table(product_aur_full_content);

                    //if (!product_aurss.product_page_urls) aurss_classes.push('ts_aurss_product_url_inactive');
                    //if (!product_page_urls) aurss_classes.push('ts_aurss_product_url_inactive');

					//Hide inactive product URLs, see GitLab #312
					!product_page_urls && aurss_classes.push('ts_aurss_product_url_inactive');

					//Generate linked-in hash tags, see GitLab #312
                    //let aurss_linked_in = '#';
                    //if (product_aurss.aurss_product_linked_in) aurss_linked_in = aurss_linked_in + product_aurss.aurss_product_linked_in;
                    if (product_aurss.aurss_product_linked_in) aurss_linked_in = product_aurss.aurss_product_linked_in; //consists of: OAID + AURSS_ID
                    else aurss_linked_in = null;

					var current_aurss_html = loop_base.ts_template
						.replace(/%aurss_classes%/g, he(aurss_classes.join(' ')))
						.replace(/%aurss_id%/g, 1 * aurss.aurss_id)
						//.replace(/%aurss_product_id%/g, he(product_aurss.aurss_product_id)) //Nemanja note: this is now deprecated (we have treatment below for each AURSS product)
						.replace(/%aurss_url%/g, he(aurss_linked_in)) //used for clickable hashtag link
                        //.replace(/%aurss_product_url_id%/g, he(product_aurss.aurss_product_linked_in)) //used for element ID only to match hashtag link from above
                        .replace(/%aurss_product_url_id%/g, he(aurss_linked_in) + '-modal') //used for element ID only to match hashtag link from above
						.replace(/%aurss_flag_position%/g, flag_position)
						.replace(/%aurss_logo%/g, he(aurss.logo_url))
						.replace(/%aurss_name%/g, he(aurss.aurss_name))
						//.replace(/%aurss_locale%/g, he(`${aurss.locale_id} (${aurss.locale_descr})`)) //heredoc or ES6 templates does not work in old browsers - as it is ES6 only feature xD
						.replace(/%aurss_locale%/g, he(aurss.locale_id + ' (' + aurss.locale_descr + ')'))
						.replace(/%aurss_recommended_yes%/g, product_aurss.recommend_yes ? 1 * product_aurss.recommend_yes : 0)
						.replace(/%aurss_recommended_no%/g, product_aurss.recommend_no ? 1 * product_aurss.recommend_no : 0)
						.replace(/%aurss_recommended_score%/g, product_aurss.recommend_yes ? (product_aurss.recommend_no ? Math.round(100 * product_aurss.recommend_yes / (product_aurss.recommend_yes + product_aurss.recommend_no)) : 100): 0)
						.replace(/%aurss_recommended_sum%/g, product_aurss.recommend_yes ? 1 * product_aurss.recommend_yes + 1 * product_aurss.recommend_no : 0)
						//.replace(/%aurss_score%/g, Math.round(product_aurss.score_sum / product_aurss.score_count))
                        .replace(/%aurss_score%/g, Math.round(product_aurss.aurss_score))
						.replace(/%aurss_score_1star_count%/g, 1 * product_aurss.stars_1 || 0)
						.replace(/%aurss_score_1star_score%/g, 100 * product_aurss.stars_1 / product_aurss.score_count || 0)
						.replace(/%aurss_score_2star_count%/g, 1 * product_aurss.stars_2 || 0)
						.replace(/%aurss_score_2star_score%/g, 100 * product_aurss.stars_2 / product_aurss.score_count || 0)
						.replace(/%aurss_score_3star_count%/g, 1 * product_aurss.stars_3 || 0)
						.replace(/%aurss_score_3star_score%/g, 100 * product_aurss.stars_3 / product_aurss.score_count || 0)
						.replace(/%aurss_score_4star_count%/g, 1 * product_aurss.stars_4 || 0)
						.replace(/%aurss_score_4star_score%/g, 100 * product_aurss.stars_4 / product_aurss.score_count || 0)
						.replace(/%aurss_score_5star_count%/g, 1 * product_aurss.stars_5 || 0)
						.replace(/%aurss_score_5star_score%/g, 100 * product_aurss.stars_5 / product_aurss.score_count || 0);


					loop_base.innerHTML = current_aurss_html;


					// ### Aurss product URLs loop begin ###

					//Get desired loop element
					var loop_aurss_product_urls = loop_base.getElementsByClassName('ts_aurss_product_urls_loop');
					if (loop_aurss_product_urls){
						//const count_aurss_product_urls = loop_aurss_product_urls.length;
						var count_aurss_product_urls = loop_aurss_product_urls.length;
						//for (let i = 0; i < count_aurss_product_urls; i++) {
						for (var i = 0; i < count_aurss_product_urls; i++) {
							//let each = null;
							var each = null;
							each = loop_aurss_product_urls[i];
							each.items_loaded = 0;

                            if (!each.ts_template) each.ts_template = each.innerHTML.replace(/%aurss_f_nop%/g, '');

                            //let urlsArray = [];
                            var urlsArray = [];
                            //let aurss_product_url_name, aurss_product_url_link = null;
                            var aurss_product_url_name, aurss_product_url_link = null;

                            if (product_page_urls) {

                                for (this_aurss_product_id in product_page_urls) {

                                    if (product_page_urls.hasOwnProperty(this_aurss_product_id)) {

                                    	//Bind URL name and link for each product URL
                                        aurss_product_url_name = product_page_urls[this_aurss_product_id].product_name_export;
                                        aurss_product_url_link = product_page_urls[this_aurss_product_id].product_page_url;

                                        //fill our tmp array
                                        urlsArray.push(
                                        	each.ts_template
												.replace(/%aurss_product_url_name%/g, he(aurss_product_url_name))
												.replace(/%aurss_product_url_link%/g, he(aurss_product_url_link))
												.replace(/%track_aurss_id%/g, he(aurss.aurss_id)) //TODO this is not used at all for tracking xD
												.replace(/%track_aurss_product_id%/g, he(this_aurss_product_id)) //TODO this is not used at all for tracking xD
										);
                                    }
                                }
                            }
                            each.innerHTML = urlsArray.join('\n'); //join array by LF
                            each.items_loaded += urlsArray.length; //???
                        }
					}
                    // ### Aurss product URLs loop end ###

					// ### Aurss reviews loop begin ###
					var loop_elements = element.getElementsByClassName('ts_aurss_product_reviews_loop');
					//console.log('kolko AUR pocetak', loop_elements.length);
					if(loop_elements.length)
					{
						//console.log('hmmmm BUGGAN elementa', loop_elements);
						var element_count = loop_elements.length;
						//console.log('kolko AUR', element_count);
						for(var element_nr = 0; element_nr < element_count; element_nr++)
						{
							//console.log('vrteska duplo zasto', element_nr, element_count);
							var loop_base = loop_elements[element_nr];
							//console.log('loop base AUR loaded before', loop_base.items_loaded);
							loop_base.items_loaded = 0;
							loop_base.pending = [];
							//console.log('loop base after', loop_base);
							//console.log('loop base AUR loaded after', loop_base.items_loaded);

							//console.log('tmpl AUR before', loop_base.ts_template);
							if(!loop_base.ts_template)
							{
								//loop_base.ts_template = loop_base.innerHTML.replace(/%er_nop%/g, '');
								loop_base.ts_template = loop_base.innerHTML.replace(/%aur_sc_nop%/g, '');
								//loop_base.ts_template = loop_base.innerHTML.replace(/%sc_full_aur_class%/g, 'hide_if_no_sc_full_aur');
								loop_base.ts_id = product_data.our_article_id; //not needed here...
							}
							//console.log('tmpl AUR after', loop_base.ts_template, loop_base.ts_id);

							var items_html = [];

							if (product_aurss_reviews_list) {

								for (this_aurss_product_id in product_aurss_reviews_list) {
									if (product_aurss_reviews_list.hasOwnProperty(this_aurss_product_id)) {
										for (var io = 0; io < product_aurss_reviews_list[this_aurss_product_id].length; io++) {
											var this_aurss_review_id = product_aurss_reviews_list[this_aurss_product_id][io];
											//console.log('io', io, 'val??', this_aurss_review_id);
											//buffer review data from full content obj
											//console.log('full aur cont obj', product_aurss_full_content);
											if (product_aurss_full_content.hasOwnProperty(this_aurss_review_id)){

												this_aurss_full_review = product_aurss_full_content[this_aurss_review_id];
												//add AUrev ID
												//aurss_review_id is now injected via back-end object
												//this_aurss_full_review.aureview_id = this_aurss_review_id;
												//Add AURSS name
												//aurss_name is now injected via back-end object
												//this_aurss_full_review.aurss_name = aurss.aurss_name;

												//push preloaded data
												items_html.push(window.testseek.render_au_review(loop_base.ts_template, this_aurss_full_review));
												//AURreviewsArray.push(window.testseek.render_au_review(eachAUR.ts_template, this_aurss_full_review));
												//console.log('loaded', this_aurss_full_review);
											}
											else loop_base.pending.push(this_aurss_review_id);
											//else eachAUR.pending.push(this_aurss_review_id);
										}
									}
								}
							}

							//ovaj ga duplira - zasto? pa zato sto inject-uje items_html array ponovo :)
							//loop_base.innerHTML = items_html.join('\n');
							loop_base.innerHTML = '';
							loop_base.items_loaded += items_html.length;


							/*items_html.push(
								loop_base.ts_template
											.replace(/%ts_show_if_sc_full_aur%/g, 'ts_show_if_sc_full_aur'));*/
							//loop_base.innerHTML = items_html.join('\n');

							if (loop_base.pending.length > 0)
							{
								//console.log('pending AUR...', loop_base.pending.length, 'loaded AUR', loop_base.items_loaded);
								loop_base.parentNode.classList.add('ts_partly_loaded');
							}
							else
							{
								//console.log('100% loaded AUR, no more pending!', loop_base.pending.length, 'loaded AUR final:', loop_base.items_loaded);
								loop_base.parentNode.classList.add('ts_fully_loaded');
							}

							//console.log('loop base AUR loaded after', loop_base.items_loaded);

							//console.log('cekalica ER', loop_base.pending.length, 'loaded', loop_base.items_loaded);

							//loop_base.innerHTML = loop_base.ts_template.replace(/%sc_full_aur_class%/g, 'hide_if_no_sc_full_aur');
							//loop_base.innerHTML = items_html.replace(/%sc_full_aur_class%/g, 'hide_if_no_sc_full_aur');
							//items_html.push(loop_base.ts_template.replace(/%sc_full_aur_class%/g, 'hide_if_no_sc_full_aur'));
									//.replace(/%aurss_f_name%/g, he(feature_name)));

						}

					}
					//else console.log('nema BUGGAN elementa', loop_elements);
					// ### Aurss reviews loop end ###

					// Aurss Features loop
					var loop_elements_2 = loop_base.getElementsByClassName('ts_aurss_feature_loop');
					if(loop_elements_2)
					{
						var element_count_2 = loop_elements_2.length;
						for(var element_nr_2 = 0; element_nr_2 < element_count_2; element_nr_2++)
						{
							var loop_base_2 = loop_elements_2[element_nr_2];
							loop_base_2.items_loaded = 0;

							if(!loop_base_2.ts_template)
							{
								loop_base_2.ts_template = loop_base_2.innerHTML.replace(/%aurss_f_nop%/g, '');
							}

							var items_html_2 = [];

							if(product_aurss.features)
							{
								for(var feature_name in product_aurss.features)
								{
									var features = product_aurss.features[feature_name];
									items_html_2.push(
										loop_base_2.ts_template
											.replace(/%aurss_f_name%/g, he(feature_name))
											.replace(/%aurss_f_score%/g, Math.round(features.sum / features.count))
											.replace(/%aurss_f_score_count%/g, 1 * features.count)
											.replace(/%aurss_f_score_sum%/g, 1 * features.sum)
									);
								}
							}
							loop_base_2.innerHTML = items_html_2.join('\n');
							loop_base_2.items_loaded += items_html_2.length;
						}
						items_html.push(loop_base.innerHTML);
					}
					else
					{
						items_html.push(current_aurss_html);
					}
				}
			}
			/*else {
				console.log('NO AURSS! hide it');
			}*/

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}

	// E-review Loop
	var loop_elements = element.getElementsByClassName('ts_ereview_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		//console.log('kolko ER', element_count); //1 a zatim 0 ???
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			//console.log('loop base before', loop_base);
			loop_base.items_loaded = 0;
			loop_base.pending = [];
			//console.log('loop base after', loop_base);

			//console.log('tmpl before', loop_base.ts_template);
			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%er_nop%/g, '');
				loop_base.ts_id = product_data.our_article_id;
			}
			//console.log('tmpl after', loop_base.ts_template);

			var items_html = [];

			// TODO: move to a review load function
			if(product_data.ereviews)
			{
				var review_count = product_data.ereviews.length;
				for(var rev_nr = 0; rev_nr < review_count; rev_nr++)
				{
					var review_id = product_data.ereviews[rev_nr];
					var review = this.ereviews[review_id];
					if(!review)
					{
						loop_base.pending.push(review_id);
					}
					else
					{
						items_html.push(window.testseek.render_e_review(loop_base.ts_template, review));
					}
				}
			}

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;

			if(loop_base.pending.length > 0)
			{
				//console.log('pending...', loop_base.pending.length, 'loaded', loop_base.items_loaded);
				loop_base.parentNode.classList.add('ts_partly_loaded');
			}
			else
			{
				//console.log('100% loaded, no more pending!', loop_base.pending.length, 'loaded', loop_base.items_loaded);
				loop_base.parentNode.classList.add('ts_fully_loaded');
			}

			//console.log('cekalica ER', loop_base.pending.length, 'loaded', loop_base.items_loaded);
		}
	}


	// Video loop
	var loop_elements = element.getElementsByClassName('ts_video_loop');
	if(loop_elements)
	{
		var element_count = loop_elements.length;
		for(var element_nr = 0; element_nr < element_count; element_nr++)
		{
			var loop_base = loop_elements[element_nr];
			loop_base.items_loaded = 0;

			if(!loop_base.ts_template)
			{
				loop_base.ts_template = loop_base.innerHTML.replace(/%vid_nop%/g, '');
			}

			var items_html = [];

			// TODO: move to a review load function
			if(product_data.videos)
			{
				var video_count = product_data.videos.length;
				for(var vid_nr = 0; vid_nr < video_count; vid_nr++)
				{
					var video_id = 1 * product_data.videos[vid_nr];
					var video = this.videos[video_id];
					if(video)
					{
						items_html.push(
							loop_base.ts_template
								.replace(/%vid_id%/g, video_id)
								.replace(/%vid_site_yid%/g, he(video.video_url))
								.replace(/%vid_name%/g, he(video.video_name))
								.replace(/%vid_desc%/g, he(video.video_description))
								.replace(/%vid_pub%/g, he(video.publish_date))
								.replace(/%vid_len%/g, he(video.video_length))
								.replace(/%vid_auth%/g, he(video.test_author))
								.replace(/%vid_image%/g, he(video.image_url))
								.replace(/%vid_thumb%/g, he(video.thumb_url))
								.replace(/%vid_type%/g, he(video.video_type_name))
								.replace(/%vid_type_name%/g, he(l10n('video_type_' + video.video_type_name)))
								.replace(/%vid_lang%/g, he(video.locale_id.split('-')[0]))
								.replace(/%vid_lang_name%/g, he(video.locale_descr.split(' - ')[0]))
								.replace(/%vid_quality%/g, he(video.video_quality))
								.replace(/%vid_site_id%/g, 1 * video.test_site_id)
								.replace(/%vid_url%/g, he(video.video_url.replace("https://www.youtube.com/watch?v=", "https://www.youtube.com/embed/")))
						);
					}
					else
					{
						break;
					}
				}
			}

			loop_base.innerHTML = items_html.join('\n');
			loop_base.items_loaded += items_html.length;
		}
	}
};


/* End of render_template.js */

/* Start of resize_iframes.js */
window.testseek.resize_iframes = function()
{
	var stat = {ok: 0, new: 0, lost: 0};
	var ifs = document.getElementsByClassName('ts_iframe');
	var frame_count = ifs.length;
	for(var if_nr = 0; if_nr < frame_count; if_nr++)
	{
		var iframe = ifs[if_nr];

		// do we have an element to calculate height from?
		if(iframe.contentDocument.body.firstChild)
		{
			// Set new height
			var height = (10 + iframe.contentDocument.body.firstChild.offsetHeight) + 'px';
			iframe.height = height
			iframe.style.height = height;
			stat.ok++;
		}
		// did we have an element?
		else if(iframe.ts_html)
		{
			// reset iframe, and trigger a inline_iframe_init() after the loop to restore it
			iframe.className = iframe.ts_init_classes;
			stat.lost++;
		}
		else
		{
			 stat.new++;
		}
	}
	//console.log(["resize_iframes", stat]);
	// if we lost some iframe, trigger init to restore them
	if(stat.lost > 0)
	{
		testseek.inline_iframe_init();
	}
}

window.testseek.delayed_resize_iframes = function(ms)
{
	if(typeof ms != "number")
	{
		ms = 500;
	}
	else if(ms <= 0)
	{
		ms = 500;
	}
	setTimeout(window.testseek.resize_iframes, ms);
}
/* End of resize_iframes.js */

/* Start of send_vote.js */
/**
 * Send vote using ajax
 *
 * @param type string ER for expert reviews, VID for video reviews, and may support more
 * @param id int id number of the entity of the given type
 * @param sign char '+' for up-votes, '-' for downvotes
 * @param callback callable function to call when ajax returns
 * @param element any used as 2nd parameter when callback is called
 *
 * @depends vote_url
 **/

window.testseek.send_vote = function(type, id, sign, callback, element)
{
	// concat type, sign and id, to get the vote string
	var vote_string = type + sign + id;

	// create an ajax object
	var ajax = new XMLHttpRequest();

	// add a listner to catch when request done
	ajax.onreadystatechange = function() {
		// ignore all states except DONE
		if(ajax.readyState == /* XMLHttpRequest.DONE */ 4)
		{
			// if ok response (http code 200)
			if(ajax.status == 200)
			{
				// if callback was provided
				if(callback)
				{
					// answer has a parsed JSON
					if(ajax.responseJSON)
					{
						// Call the callback with json and elemnt as argument
						callback(ajax.responseJSON, element);
					}
					else
					{
						// Parse the respone to json, and call the callback with the json and elemnt as argument
						callback(JSON.parse(ajax.responseText), element);
					}
				}
				else if(window.testseek.verbose)
				{
					// just log the response
					console.log(ajax.status);
					console.log(ajax);
				}
			}

			// other responses, and there is a callback provided
			else if(callback)
			{
				// Call the callback with a negative json and elemnt as argument
				callback({"ok": false}, element);
			}
		}
	};

	// Send request
	ajax.open("POST", window.testseek.vote_url + vote_string, true);
	ajax.send();
}
/* End of send_vote.js */

/* Start of svg_graph_load.js */
window.testseek.svg_graph_load = function() {
	var graphs = document.getElementsByClassName('ts_clock_graph');
	for(var g_nr = graphs.length; g_nr > 0;)
	{
		var graph = graphs[--g_nr];
		var value = parseFloat(graph.getAttribute('data-ts-graph-val'));
		var sufix = graph.getAttribute('data-id-sufix');
		if(sufix)
		{
			sufix = '_' + sufix;
		}
		else
		{
			sufix = '';
		}

		if(value)
		{
			var fg = graph.getElementById('fg' + sufix);
			var fg1 = graph.getElementById('fg1' + sufix);
			var fg2 = graph.getElementById('fg2' + sufix);
			var clockarm = graph.getElementById('clockarm' + sufix);

			if(fg)
			{
				if(value < 20)
				{
					fg.setAttribute('stroke', '#de5a5a');
				}
				else if(value < 40)
				{
					fg.setAttribute('stroke', '#fba7a7');
				}
				else if(value < 60)
				{
					fg.setAttribute('stroke', '#f1bf70');
				}
				else if(value < 80)
				{
					fg.setAttribute('stroke', '#87d962');
				}
				else
				{
					fg.setAttribute('stroke', '#5dab39');
				}

				fg1 = fg;
			}

			if(fg1)
			{
				var r = parseFloat(fg1.getAttribute('r'));
				var rv = 0.02 * r * Math.PI * value;
				var rv2 = 0.02 * r * Math.PI * (100 - value);
				fg1.setAttribute('stroke-dasharray', [rv, rv2].join(' '));

				if(fg2)
				{
					fg2.setAttribute('stroke-dasharray', [rv2, rv].join(' '));
				}

				if(clockarm)
				{
					var clockarm_transform = clockarm.getAttribute('transform');

					// IE 11 fix
					if(clockarm_transform == 'rotate(0)')
					{
						clockarm_transform = 'rotate(0 ' + fg2.getAttribute('cx') + ' ' + fg2.getAttribute('cy') + ')';
					}

					clockarm_transform = clockarm_transform.replace(/rotate\([0-9.,]+ /, 'rotate(' + 3.6 * value + ' ');
					clockarm.setAttribute('transform', clockarm_transform);
				}
			}

			// modern browsers
			if(graph.classList)
			{
				graph.classList.remove('ts_clock_graph');
			}
			// Walkaround for IE 11
			else
			{
				graph.setAttribute("class", (' ' + graph.getAttribute("class") + ' ').replace(/\s+/, ' ').replace(' ts_clock_graph ', ' ') .trim());
			}
		}
	}
}
/* End of svg_graph_load.js */

/* Start of tab_select.js */
window.testseek.tab_select = function(tab_element, content_container) {
	var selected_key = tab_element.getAttribute('data-ts-tab');
	var tab_count = tab_element.parentNode.children.length;

	for(var ci = 0; ci < tab_count; ci++)
	{
		var tab_child = tab_element.parentNode.children[ci];
		tab_child.classList.remove('selected');
	}
	tab_element.classList.add('selected');

	var content_container_count = content_container.children.length;
	for(var ci = 0; ci < content_container_count; ci++)
	{
		var content_child = content_container.children[ci];
		var content_child_key = content_child.getAttribute('data-ts-tab');

		if(!content_child_key)
		{
			continue;
		}

		if(typeof(content_child.display_type) == 'undefined')
		{
			content_child.display_type = content_child.style.display;
			if(content_child.display_type == 'none')
			{
				content_child.display_type = 'block';
			}
		}

		if(content_child_key == selected_key)
		{
			content_child.style.display = content_child.display_type;
		}
		else
		{
			content_child.style.display = 'none';
		}
	}
}

window.testseek.tab_select_init = function() {
	var tab_containers = document.getElementsByClassName('testseek_tabs');
	var tab_containers_count = tab_containers.length;

	for(var tci = 0; tci < tab_containers_count; tci++)
	{
		var best_tab = null;
		var tab_container = tab_containers[tci];
		var tab_container_count = tab_container.children.length;

		for(var ci = 0; ci < tab_container_count; ci++)
		{
			var tab_child = tab_container.children[ci];
			var tab_child_key = tab_child.getAttribute('data-ts-tab');
			var tab_child_value = tab_child.getAttribute('data-ts-value');

			if(!tab_child_key)
			{
				continue;
			}

			if(parseInt(tab_child_value) > 0)
			{
				best_tab = tab_child;
				break;
			}
			else if(!best_tab)
			{
				best_tab = tab_child;
			}
		}

		if(best_tab)
		{
			best_tab.click();
		}
	}
}
/* End of tab_select.js */

/* Start of track_ext_link.js */
window.testseek.track_ext_link = function(url, type, id1, id2)
{
	if(window.testseek.tracking)
	{
		window.testseek.click_count++;

		var ajax = new XMLHttpRequest();
		ajax.onreadystatechange = function() {
			if(window.testseek.verbose)
			{
				console.log(ajax.responseText);
			}
		};

		ajax.open("POST", window.testseek.search_url, true);
		ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		var parameters = "track[type]=" + encodeURIComponent(type);
		parameters += "&track[id1]=" + parseInt(id1);
		//console.log(id1, id2); //Nemanja note: see what to do with such conception
		parameters += "&track[id2]=" + parseInt(id2); //Nemanja note: OMG FFS. AURSS links are often strings!
		parameters += "&track[count]=" + window.testseek.click_count;
		parameters += "&track[url]=" + encodeURIComponent(url);
		ajax.send(parameters);
	}

	return true;
}

window.testseek.click_count = 0;

window.testseek.track_er_link = function(url, review_id, test_site_id)
{
	return window.testseek.track_ext_link(url, 'er_link', review_id, test_site_id);
}

window.testseek.track_aur_link = function(url, aurss_id, product_id)
{
	return window.testseek.track_ext_link(url, 'aur_link', aurss_id, product_id);
}

window.testseek.track_ts_link = function(url)
{
	return window.testseek.track_ext_link(url, 'ts_link', 0, 0);
}

window.testseek.track_this_er_link = function(element)
{
	return window.testseek.track_er_link(element.href, element.getAttribute('data-tseek-rev-id'), element.getAttribute('data-tseek-site-id'));
}

window.testseek.track_this_aur_link = function(element)
{
	return window.testseek.track_aur_link(element.href, element.getAttribute('data-tseek-aurss-id'), element.getAttribute('data-tseek-prod-id'));
}

window.testseek.track_this_ts_link = function(element)
{
	return window.testseek.track_ts_link(element.href);
}
/* End of track_ext_link.js */

/* Start of update_class.js */
window.testseek.update_class = function(element, product_data)
{
	var noAER = false;
	var noAUR = false;

	//define default property value when rich snippet is loaded
	if ('ts_rich_snippet' === element.id) element.tsHideRS = false;

	var classes = [];
	if(element.ts.className)
	{
		classes.push(element.ts.className);
	}

	if(!product_data || !product_data.config)
	{
		classes.push("ts_product_na");
		element.className = classes.join(' ');
	}

	var s = product_data.config.show;

	if(!s.base)
	{
		classes.push("ts_base_na");
	}

	if(!s.er && !s.ers)
	{
		classes.push("ts_ereviews_na");
        noAER = true;
	}
	// no reviews
	else if(product_data.aer_count_all <= 0)
	{
		classes.push("ts_ereviews_none");
		classes.push("ts_ereviews_no_score");
        noAER = true;
	}
	// ereviews without score
	else if(product_data.aer_avg_score_subset <= 0)
	{
		classes.push("ts_ereviews_have");
		classes.push("ts_ereviews_no_score");
        //do not hide in this case - show even if no score

		//buf if we don't have any reviews either. hide it!
		if (!product_data.ereviews) {
		    noAER = true;
            classes.push("ts_ereviews_none"); //TODO put this in down below IF: if noAER...
        }
	}
	// pretend we don't have reviews, if score to low
	else if(window.testseek.filters.product_min_er_score > product_data.aer_avg_score_subset)
	{
		classes.push("ts_ereviews_none");
		classes.push("ts_ereviews_no_score");
        noAER = true;
	}
	// ereviews with score
	else
	{
		classes.push("ts_ereviews_have");
		classes.push("ts_ereviews_have_score");
	}

	if(product_data.e_cons && product_data.e_cons.length > 0)
	{
		classes.push("ts_ereviews_any_cons");
	}
	else
	{
		classes.push("ts_ereviews_no_cons");
	}
	if(product_data.e_pros && product_data.e_pros.length > 0)
	{
		classes.push("ts_ereviews_any_pros");
	}
	else
	{
		classes.push("ts_ereviews_no_pros");
	}

	//AUR pros & cons - Nemanja add-on
	if(!product_data.a_pros || 0 === product_data.a_pros.length)
    {
        classes.push("ts_aur_no_pros");
    }

    if(!product_data.a_cons || 0 === product_data.a_cons.length)
    {
        classes.push("ts_aur_no_cons");
    }

    if(!product_data.aur_features || 0 === product_data.aur_features.length)
    {
        classes.push("ts_aur_features_no_summary");
    }

	if(product_data.awards && product_data.awards.length > 0)
	{
		classes.push("ts_ereviews_any_award");
	}
	else
	{
		classes.push("ts_ereviews_no_award");
	}

	if(!s.vid)
	{
		classes.push("ts_videos_na");
	}
	else if(product_data.videos_count_all > 0)
	{
		classes.push("ts_videos_have");
	}
	else
	{
		classes.push("ts_videos_none");
	}


	if(!s.aur)
	{
		classes.push("ts_aureviews_na"); //WTF??
        //noAUR = true;
	}

	//if(!s.aurs || !product_data.aurss) //Nemanja add-on 2nd condition: Hide entire section if no AURSS was found in web service response (AURSS filtered by user choice)
	if(!s.aurs)
	{
		classes.push("ts_aureviews_summary_na");

        noAUR = true;

       //console.log('!s.aurs');
	}
	else if(product_data.aur_count_subset > 0) //Note: this is now both subset and global value (if no filters are applied)
	{
		//if(product_data.avg_aur_score <= 0)
		if(product_data.aur_avg_score <= 0) //this is real subset value
		{
			//classes.push("ts_aureviews_have");
            classes.push("ts_aureviews_none");
            classes.push("ts_aureviews_no_score");
            noAUR = true;
            //console.log('product_data.aur_avg_score <= 0');
		}
		// pretend we don't have reviews, if score to low
		//else if(window.testseek.filters.product_min_aur_score > product_data.avg_aur_score)
		else if(window.testseek.filters.product_min_aur_score > product_data.aur_avg_score) //this is real subset to compare against
		{
			classes.push("ts_aureviews_none");
			classes.push("ts_aureviews_no_score");
            //for tmpl2 (Business), hide AUR tab xD
            classes.push('ts_aur_tab_tmpl2_hide');
            noAUR = true;
            //console.log('pretend we don\'t have reviews, if score to low:', window.testseek.filters.product_min_aur_score, product_data.aur_avg_score);
		}
		else
		{
			classes.push("ts_aureviews_have");
			classes.push("ts_aureviews_have_score");
            //console.log('??? ELSE aur_count_subset, score have aurev have');
            //noAUR = true;
		}
	}
	else
	{
		classes.push("ts_aureviews_none");
		classes.push("ts_aureviews_no_score");
        noAUR = true;
        //console.log('ELSE AUR, score NO aurev none, EOL');
        /*console.log('ELSE AUR??');
        console.log(s);
        return;*/
	}

    if(!s.ur)
	{
		classes.push("ts_ureviews_na");
	}
	else
	{
		classes.push("ts_ureviews_na");
	}

	if(product_data.our_award_id)
	{
		classes.push('ts_have_ts_award');
	}
	else
	{
		classes.push('ts_no_ts_award');
	}


    //no AER, no AUR, hide it completely
    if (noAER && noAUR) {
        //console.log('NO AUR, NO AER, HIDE BOX', product_data.our_article_id, noAER, noAUR);

        //hide entire box for stars tmpl
        classes.push('ts_stars_tmpl_hide');

        //hide entire box for embedded tmpl
        classes.push('ts_live_api_box_hide');

		//hide entire rich snippet node when no AER and no AUR ratings are available
		if ('ts_rich_snippet' === element.id){

			//console.log('update class trigger! NO AUR NOR AER data, hide LD+JSON element!', element.id);

			//hide entire node by setting this element property
			element.tsHideRS = true;
		}

    }

    element.className = classes.join(' ');

}
/* End of update_class.js */

/* Start of video_filter.js */
window.testseek.video_filter = function(filter_type, select, frame) {
	var class_prefix = 'ts_video_' + filter_type + '_';
	var selected = select.value;
	var videos = frame.getElementsByClassName('ts_video');
	var video_count = videos.length;
	for(video_nr = 0; video_nr < video_count; video_nr++)
	{
		var video = videos[video_nr];
		if(select.value && !video.classList.contains(class_prefix + select.value))
		{
			video.classList.add(class_prefix + 'hide');
		}
		else
		{
			video.classList.remove(class_prefix + 'hide');
		}
	}
}
/* End of video_filter.js */

/* Start of video_vote.js */
window.testseek.video_vote_up = function(id, element)
{
	var callback = function(a, e) {
		if(a.ok)
		{
			var elements = e.parentNode.getElementsByClassName('ts_vote_up');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}
			var current_value = parseInt(elements[0].innerHTML);
			var new_value = parseInt(old_value) + 1;
			elements[0].innerHTML = new_value;
			var changed = (new_value != parseInt(current_value));

			var elements = e.parentNode.getElementsByClassName('ts_vote_down');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}
			elements[0].innerHTML = parseInt(old_value);

			var elements = e.parentNode.getElementsByClassName('ts_vote_message');
			if(!elements)
			{
				return true;
			}
			if(!elements[0])
			{
				return true;
			}
			if(!elements[0].getAttribute)
			{
				return true;
			}

			elements[0].innerHTML = window.testseek.l10n(changed ? 'vote_sucess' : 'vote_only_once');

			return true;
		}

		if(window.testseek.verbose)
		{
			console.log(a);
		}

		return false;
	}

	window.testseek.send_vote('VID', id, '+', callback, element);
}

window.testseek.video_vote_down = function(id, element)
{
	var callback = function(a, e) {
		if(a.ok)
		{
			var elements = e.parentNode.getElementsByClassName('ts_vote_down');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}
			var current_value = parseInt(elements[0].innerHTML);
			var new_value = parseInt(old_value) + 1;
			elements[0].innerHTML = new_value;
			var changed = (new_value != parseInt(current_value));

			var elements = e.parentNode.getElementsByClassName('ts_vote_up');
			if(!elements)
			{
				return false;
			}
			if(!elements[0])
			{
				return false;
			}
			if(!elements[0].getAttribute)
			{
				return false;
			}
			var old_value = elements[0].getAttribute('data-ts-value');
			if(!old_value)
			{
				return false;
			}
			elements[0].innerHTML = parseInt(old_value);

			var elements = e.parentNode.getElementsByClassName('ts_vote_message');
			if(!elements)
			{
				return true;
			}
			if(!elements[0])
			{
				return true;
			}
			if(!elements[0].getAttribute)
			{
				return true;
			}

			elements[0].innerHTML = window.testseek.l10n(changed ? 'vote_sucess' : 'vote_only_once');

			return true;
		}

		if(window.testseek.verbose)
		{
			console.log(a);
		}

		return false;
	}

	window.testseek.send_vote('VID', id, '-', callback, element);
}

window.testseek.refresh_video_voting = function(id, element) {
	var video = window.testseek.videos[id];
	if(video)
	{
		var up = element.getElementsByClassName('ts_vote_up');
		var down = element.getElementsByClassName('ts_vote_up');
		if(up[0])
		{
			up[0].setAttribute('data-ts-value', video.up_votes);
			up[0].innerHTML = 1 * video.up_votes;
		}
		if(dows[0])
		{
			down[0].setAttribute('data-ts-value', video.down_votes);
			down[0].innerHTML = 1 * video.down_votes;
		}
	}
}
/* End of video_vote.js */

/* Start of l10n.2.js */
/**
 * Translations
 *
 * @param tr_key String translation key string
 *
 * @return String translation (this version: Proper English)
 */

window.testseek.l10n = function(tr_key)
{
	// lookup the english key string
	switch(tr_key)
	{
		// video_types:
		case 'video_type_review':
			return "Review";

		case 'video_type_unboxing':
			return "Unboxing";

		case 'video_type_official':
			return "Official";

		case 'video_type_guide':
			return "Guide";

		case 'vote_sucess':
			return "Thank you! Your vote has been registered";

		case 'vote_only_once':
			return "You can only vote once per review";

		// Unknown: types
		default:
			return tr_key;
	}
}/* End of l10n.2.js */

	/* init */
	window.testseek.init();
	window.testseek.init_css(window.testseek.ts_domain);
	window.testseek.init_font();
